import { billingIt } from "./billing.it";
import { hrIt } from "./hr.it";
import { dashboardIt } from "./dashboard.it";
import { paymentsIt } from "./payments.it";
import { reportsIt } from "./reports.it";
import type { MessageId } from "./fr";

/** Italian catalog. Same keys and {placeholders} as fr.ts (checked by catalogs.t.ts). */
// Terms: feature = funzionalità; feature enablement = abilitazione; role = ruolo; case (dossier) = pratica; pro = pro; client = cliente; job request (demande) = richiesta; lead (opportunité) = opportunità; reason (motif) = motivo; reveal (afficher) = mostrare; staff member = membro del team; sign out = Esci; audit log = registro di audit.
export const it: Record<MessageId, string> = {
  ...reportsIt,
  ...paymentsIt,
  ...dashboardIt,
  ...billingIt,
  ...hrIt,
  // ── Brand and shell ──
  "brand.name": "Walliyo",
  "brand.initial": "W",
  "brand.console": "Console",
  "nav.aria": "Console",
  "nav.new": "NUOVO",
  "nav.group.configuration": "Configurazione",
  "overview.eachDepartment": "Ogni reparto, una riga",
  "overview.dept.marketplace": "Operazioni di mercato",
  "overview.dept.growth": "Vendite e crescita",
  "overview.dept.support": "Assistenza clienti",
  "overview.dept.trust": "Fiducia e sicurezza",
  "overview.dept.finance": "Finanza",
  "overview.dept.people": "Risorse umane",
  "overview.dept.administration": "Amministrazione",
  "overview.dept.product": "Tecnica",
  "overview.clickThrough": "clicchi per andarci",
  "overview.numberToWatch": "Il numero da tenere d'occhio",
  "overview.whereWalliyoWorks": "Dove lavora Walliyo",
  "overview.noCitiesYet": "Nessuna richiesta questo mese.",
  "overview.points": "{points} punti",
  "overview.title.people.walliyoMonth": "Walliyo, {month}",
  "overview.people.tab.waiting": "Cosa ti aspetta",
  "overview.people.tab.company": "L'azienda",
  "overview.people.tab.weeks": "Le settimane a venire",
  "overview.people.askForTimeOff": "Chiedere ferie",
  "overview.people.joinedThisMonth": "{count} entrati questo mese",
  "overview.people.joinedThisMonth.one": "1 entrato questo mese",
  "overview.people.candidates": "{count} candidati",
  "overview.people.candidates.one": "1 candidato",
  "overview.people.medianStay": "Anni, permanenza mediana",
  "overview.people.whereEverybodyIs": "Dove sta ognuno",
  "overview.people.oneLinePerTeam": "una riga per squadra",
  "overview.people.noTeamsYet": "Ancora nessuna squadra.",
  "overview.people.noLead": "senza responsabile",
  "overview.people.nobodyCovering": "Nessuno a coprire",
  "overview.people.thinWeek": "{team} perde {away} su {size} nella settimana del {week}.",
  "overview.people.whoIsWhere": "Chi è dove",
  "overview.people.fourWeeks": "quattro settimane, e cosa cade in ognuna",
  "overview.people.allTimeOff": "Tutte le ferie",
  "overview.people.quietWeeks": "Nulla cade nelle prossime quattro settimane.",
  "overview.people.mark.payrollCloses": "le buste paga chiudono {on}",
  "overview.people.mark.reviewsClose": "le valutazioni chiudono {on}",
  "overview.people.span.leave": "{days} giorni di ferie",
  "overview.people.span.leave.one": "1 giorno di ferie",
  "overview.people.span.leavePending": "{days} giorni · da decidere",
  "overview.people.span.leavePending.one": "1 giorno · da decidere",
  "overview.people.span.starts": "inizia",
  "overview.people.task.candidates": "{count} candidati ti aspettano",
  "overview.people.detail.candidates": "per {second} posizioni aperte",
  "marketplace.seeAll": "Vedi tutti i {count}",
  "marketplace.findAPro": "Trovare un pro",
  "marketplace.theMarket": "Il mercato, questa settimana",
  "overview.title.marketplace.theMarket": "Il mercato, questa settimana",
  "overview.lede.marketplace.nobodyAnswered": "{first} persone hanno chiesto qualcosa e nessuno ha risposto.",
  "overview.lede.marketplace.demandNoSupply": "{first} mestieri sono richiesti dove nessun pro ha la competenza.",
  "overview.lede.marketplace.quiet": "Questa settimana non è stato pubblicato nulla.",
  "overview.lede.marketplace.allAnswered": "Ogni lavoro di questa settimana ha ricevuto un preventivo.",
  "overview.people.link.employees": "Dipendenti",
  "overview.people.link.recruiting": "Selezione",
  "overview.people.link.learning": "Formazione",
  "overview.people.link.teams": "Squadre",
  "overview.administration.askedNotAnswered": "Chiesto, senza risposta",
  "overview.administration.oldestFirst": "il più vecchio prima",
  "overview.administration.nobodyWaiting": "Nessuno attende una risposta.",
  "overview.administration.row.wantsUntil": "{subject} vuole poter {asked}",
  "overview.administration.row.wantsForever": "{subject} vuole poter {asked}, senza data di fine",
  "overview.administration.until": "fino al {on}",
  "overview.administration.noEndAsked": "nessuna data di fine richiesta",
  "overview.administration.hoursWaiting": "{hours} ore di attesa",
  "overview.administration.hoursWaiting.one": "1 ora di attesa",
  "overview.administration.pastTheDeadline": "scadenza superata",
  "overview.administration.nobodyTookItBack": "Nessuno l'ha ripreso",
  "overview.administration.noEndDate": "{count} accessi non hanno data di fine.",
  "overview.administration.noEndDate.one": "1 accesso non ha data di fine.",
  "overview.administration.belongToLeavers": "{leavers} appartengono a chi è andato via.",
  "overview.administration.belongToLeavers.one": "1 appartiene a chi è andato via.",
  "overview.administration.reviewThem": "Rivederli",
  "overview.administration.criticalCapabilities": "Capacità critiche",
  "overview.administration.ifAnyReachesOne":
    "Se una di queste scende a una persona, nessuno può coprire la sua assenza.",
  "overview.figure.holdCritical": "Detengono qualcosa di critico",
  "overview.lede.administration.waitingAndGrants":
    "{first} persone attendono una risposta, e {second} accessi non hanno data di fine.",
  "overview.lede.administration.waiting": "{first} persone attendono una risposta.",
  "overview.lede.administration.grants": "{first} accessi non hanno data di fine e nessuno li ha ripresi.",
  "overview.lede.administration.nothingWaiting": "Nessuno attende una risposta.",
  "overview.growth.step.signedUp": "Iscritti",
  "overview.growth.step.verified": "Verificati",
  "overview.growth.step.addedSkill": "Hanno aggiunto un mestiere",
  "overview.growth.step.quotedOnce": "Hanno preventivato una volta",
  "overview.growth.step.wonAJob": "Hanno vinto un lavoro",
  "overview.growth.lost.signedUp": "mai iscritti",
  "overview.growth.lost.verified": "hanno rinunciato",
  "overview.growth.lost.addedSkill": "non l'hanno mai fatto",
  "overview.growth.lost.quotedOnce": "non hanno mai preventivato",
  "overview.growth.lost.wonAJob": "non hanno mai vinto",
  "overview.growth.stuck": "Bloccati, e da chiamare",
  "overview.growth.stuckWho": "verificati, in un mestiere richiesto, mai preventivato",
  "overview.growth.nobodyStuck": "Nessuno è bloccato.",
  "overview.growth.row.workGoingUnanswered": "{subject}",
  "overview.growth.why.workGoingUnanswered":
    "verificato {days} giorni fa · il lavoro nel suo mestiere resta senza risposta",
  "overview.growth.row.neverQuoted": "{subject}",
  "overview.growth.why.neverQuoted": "verificato {days} giorni fa · non ha mai preventivato nulla",
  "overview.growth.promoCost": "Ha dato {given} in sconti contro {earned} di commissioni dai pro che l'hanno usata.",
  "overview.growth.promoUsed": "{used} pro l'hanno usata",
  "overview.growth.beforeYouCampaign": "Prima di lanciare una campagna",
  "overview.growth.notificationsAreFree":
    "Le notifiche nell'app raggiungono questi pro gratuitamente. L'SMS costa a messaggio, e qui i dati si pagano a ora.",
  "overview.action.call": "Chiamare",
  "overview.lede.growth.neverQuoted":
    "{first} pro si sono iscritti e non hanno mai preventivato nulla. È tutto il lavoro.",
  "overview.lede.growth.nobodySignedUp": "Questo mese nessuno si è iscritto.",
  "overview.lede.growth.allWorking": "Ogni pro iscritto ha preventivato qualcosa.",
  "overview.support.dueInMinutes.one": "scadenza tra 1 minuto",
  "overview.support.dueInHours.one": "scadenza tra 1 ora",
  "overview.support.overdue.one": "1 minuto oltre la scadenza",
  "overview.support.nobodyOwnsWhy.one":
    "Un caso senza titolare è un caso a cui nessuno risponde. Il più vecchio è lì da 1 giorno.",
  "overview.people.days.one": "1 giorno",
  "overview.people.payrollOpen.one": "{month} è aperto. Si chiude domani.",
  "overview.people.detail.leave.one": "Chiesto 1 giorno fa · sei il suo responsabile",
  "overview.finance.waiting.one": "1 giorno di attesa",
  "overview.trust.row.appealWaiting.one": "Ricorso in attesa da 1 giorno",
  "overview.trust.legalHoldsWhy.one":
    "1 account è bloccato. Nulla che lo riguardi può essere cancellato, nemmeno su richiesta dati.",
  "overview.product.unconfirmed.one": "1 callback non confermato, {minutes} minuti fa.",
  "overview.product.whatIsBroken": "Cosa è rotto",
  "overview.product.worstFirst": "il peggiore prima",
  "overview.product.nothingBroken": "Niente è rotto.",
  "overview.product.unconfirmed": "{count} callback non confermati, il più vecchio {minutes} minuti fa.",
  "overview.product.unconfirmedWhy": "Ognuno è un pro che ha pagato e non risulta pagato.",
  "overview.product.replayThem": "Rieseguirli",
  "overview.product.rolledOut": "Rilasciato ai clienti",
  "overview.product.tally.everybody": "Tutti",
  "overview.product.tally.someAccounts": "Alcuni account",
  "overview.product.tally.off": "Disattivato",
  "overview.figure.rolloutsInFlight": "Rilasci in corso",
  "overview.product.row.incidentOpen": "{subject}",
  "overview.product.why.incidentOpen": "aperto da {amount} · i clienti vedono l'avviso",
  "overview.product.row.ruleScheduled": "La regola entra in vigore {at}",
  "overview.product.why.ruleScheduled": "{subject} {amount} · nessuno ha approvato",
  "overview.product.row.experimentRunning": "{subject} sul {days}% dei clienti",
  "overview.product.why.experimentRunning": "in corso dal {on} · pronto da decidere",
  "overview.figure.incidentsOpen": "Incidenti aperti",
  "overview.lede.product.incidentAndCallbacks":
    "{first} incidente è aperto, e {second} callback di pagamento sono falliti.",
  "overview.lede.product.incident": "{first} incidente è aperto.",
  "overview.lede.product.callbacks": "{first} callback di pagamento sono falliti e nessuno li ha rieseguiti.",
  "overview.lede.product.rulesScheduled": "{first} regole entrano in vigore senza nessuno presente.",
  "overview.lede.product.nothingBroken": "Niente è rotto.",
  "overview.finance.aboveLimit": "Sopra il limite di qualcuno",
  "overview.finance.theyAskedYouDecide": "hanno chiesto, decidi tu",
  "overview.finance.nothingWaitingHere": "Nulla è in attesa di approvazione.",
  "overview.finance.theirLimit": "limite {ceiling}",
  "overview.finance.noLimit": "non ha alcun limite",
  "overview.finance.waiting": "{days} giorni di attesa",
  "overview.finance.today": "oggi",
  "overview.finance.subscriptions": "Abbonamenti",
  "overview.finance.tally.endingSoon": "Rinnovo entro 7 giorni",
  "overview.finance.tally.suspended": "Pagamento fallito",
  "overview.finance.tally.ended": "Terminati, non rinnovati",
  "overview.finance.promosRunning": "Promozioni in corso",
  "overview.finance.promoEnds": "{name} finisce il {on}.",
  "overview.finance.promoNoEnd": "{name} non ha data di fine.",
  "overview.finance.promoCost": "Ha dato {given} in sconti contro {earned} di commissioni.",
  "overview.figure.feesCollected": "Commissioni incassate",
  "overview.figure.jobsBilled": "Lavori fatturati",
  "overview.figure.renewalsFailed": "Rinnovi falliti",
  "overview.lede.finance.waitingOnApproval": "{first} correzioni attendono qualcuno che possa approvarle.",
  "overview.lede.finance.renewalsFailed": "{first} rinnovi sono falliti e nessuno li ha ripresi.",
  "overview.lede.finance.renewingSoon": "{first} abbonamenti si rinnovano questa settimana.",
  "overview.lede.finance.nothingWaiting": "Nulla è in attesa di approvazione.",
  "overview.trust.needsDecision": "Da decidere oggi",
  "overview.trust.mostSeriousFirst": "il più grave prima",
  "overview.trust.nothingUrgentHere": "Niente da decidere oggi.",
  "overview.trust.verificationQueue": "Coda di verifica",
  "overview.trust.whyVerify": "Un pro in attesa di verifica non può essere trovato né ingaggiato.",
  "overview.trust.tally.underADay": "In attesa da meno di 24 h",
  "overview.trust.tally.overADay": "Oltre 24 h",
  "overview.trust.legalHolds": "Blocchi legali",
  "overview.trust.legalHoldsWhy":
    "{count} account sono bloccati. Nulla che li riguardi può essere cancellato, nemmeno su richiesta dati.",
  "overview.trust.row.criticalUnreferred": "{subject}",
  "overview.trust.why.criticalUnreferred": "critico · non segnalato alla polizia",
  "overview.trust.row.restrictionExpiring": "La restrizione si toglie da sola il {on}",
  "overview.trust.why.restrictionExpiring": "{subject} · togliila, o si toglie da sola",
  "overview.trust.row.appealWaiting": "Ricorso in attesa da {days} giorni",
  "overview.trust.why.appealWaiting": "un account limitato ha chiesto un riesame",
  "overview.figure.underLegalHold": "Sotto blocco legale",
  "overview.lede.trust.criticalUnreferred": "{first} segnalazioni sono critiche e nessuna è stata inoltrata.",
  "overview.lede.trust.waitingOverADay": "{first} pro attendono la verifica da più di un giorno.",
  "overview.lede.trust.waitingToVerify": "{first} pro attendono la verifica.",
  "overview.lede.trust.nothingUrgent": "Niente da decidere oggi.",
  "overview.support.runningOut": "Il tempo stringe",
  "overview.support.soonestFirst": "scadenza più vicina prima",
  "overview.support.nothingDue": "Nessuna scadenza è imminente.",
  "overview.support.whereFrom": "Da dove sono arrivati",
  "overview.support.noChannels": "Nessun caso aperto.",
  "overview.support.channel.chat": "Nell'app",
  "overview.support.channel.phone": "Telefono",
  "overview.support.channel.email": "E-mail",
  "overview.support.nobodyOwns": "{count} senza titolare",
  "overview.support.nobodyOwnsWhy":
    "Un caso senza titolare è un caso a cui nessuno risponde. Il più vecchio è lì da {days} giorni.",
  "overview.support.takeOldest": "Prendi il più vecchio",
  "overview.support.row.mine": "tuo",
  "overview.support.row.theirs": "di qualcun altro",
  "overview.support.row.unclaimed": "senza titolare",
  "overview.support.dueInMinutes": "scadenza tra {minutes} minuti",
  "overview.support.dueInHours": "scadenza tra {hours} ore",
  "overview.support.overdue": "{minutes} minuti oltre la scadenza",
  "overview.figure.toFirstReply": "Alla prima risposta",
  "overview.action.reply": "Rispondere",
  "overview.action.claim": "Prendere",
  "overview.lede.support.breaching": "{first} casi stanno per superare la scadenza.",
  "overview.lede.support.breachingSomeYours": "{first} casi stanno per superare la scadenza. {second} sono tuoi.",
  "overview.lede.support.unclaimed": "{first} casi aspettano che qualcuno li prenda.",
  "overview.lede.support.nothingBreaching": "Nessun caso sta per superare la scadenza.",
  "overview.against": "rispetto a {month}",
  "overview.title.executive.walliyoMonth": "Walliyo, {month}",
  "overview.title.people.thingsNeedYou": "{count} cose ti aspettano",
  "overview.title.people.nothingNeedsYou": "Niente ti aspetta",
  "overview.title.support.bonjour": "Ciao, {name}",
  "overview.title.trust.safetyToday": "Sicurezza, oggi",
  "overview.title.finance.theMoney": "Il denaro, questa settimana",
  "overview.title.product.themOrUs": "Sono loro o siamo noi",
  "overview.title.growth.gettingProsWorking": "Mettere al lavoro i pro",
  "overview.title.administration.whoMayDoWhat": "Chi può fare cosa",
  "overview.title.marketplace.plain": "Panoramica",
  "overview.title.legal.plain": "Panoramica",
  "overview.lede.executive.grewFaster":
    "Il mercato è cresciuto. Ciò che non è riuscito a servire è cresciuto più in fretta.",
  "overview.lede.executive.wentUnanswered": "{first} richieste sono rimaste senza risposta questo mese.",
  "overview.lede.executive.quiet": "Questo mese non è stato pubblicato nulla.",
  "overview.lede.executive.holding": "{second} richieste pubblicate, e ognuna ha trovato una risposta.",
  "overview.people.allClear": "Niente ti aspetta. Tutto è stato trattato.",
  "overview.people.theCompany": "L'azienda",
  "overview.people.employees": "dipendenti",
  "overview.people.teams": "squadre",
  "overview.people.yours": "I tuoi",
  "overview.people.leaveLeft": "Ferie rimaste",
  "overview.people.days": "{days} giorni",
  "overview.people.noAllowance": "non definito",
  "overview.people.coursesDue": "Corsi da fare",
  "overview.people.payroll": "Buste paga",
  "overview.people.payrollOpen": "{month} è aperto. Si chiude tra {days} giorni.",
  "overview.people.payrollDue": "{month} è aperto e la data di chiusura è passata.",
  "overview.people.payrollClosed": "{month} è chiuso.",
  "overview.people.linesChecked": "{checked} righe verificate su {total}",
  "overview.people.task.leave": "{subject} chiede {count} giorni di ferie",
  "overview.people.detail.leave": "Chiesto {days} giorni fa · sei il suo responsabile",
  "overview.people.task.grantsNoEndDate": "{count} accessi non hanno data di fine",
  "overview.people.detail.grantsNoEndDate": "{second} appartengono a persone che guidi",
  "overview.people.task.reviews": "{count} valutazioni sono tue da scrivere",
  "overview.people.detail.reviews": "si chiude il {on}",
  "overview.people.task.starting": "{subject} inizia il {on}",
  "overview.people.detail.starting": "ruolo già assegnato",
  "overview.people.task.startingNoRole": "{subject} inizia il {on}",
  "overview.people.detail.startingNoRole": "nessun ruolo assegnato",
  "overview.action.decide": "Decidere",
  "overview.action.review": "Rivedere",
  "overview.action.write": "Scrivere",
  "overview.action.setUp": "Configurare",
  "overview.action.open": "Aprire",
  "overview.hero.jobsPosted": "Richieste pubblicate",
  "overview.hero.gotAQuote": "Con preventivo",
  "overview.hero.fees": "Commissioni, GNF",
  "overview.hero.activePros": "Professionisti attivi",
  "overview.hero.employees": "Dipendenti",
  "overview.headline.unanswered": "{count} richieste senza risposta · {second} mestieri scoperti",
  "overview.headline.neverQuoted": "{count} professionisti iscritti e mai risposto",
  "overview.headline.breaching": "{count} pratiche quasi scadute · {second} senza titolare",
  "overview.headline.criticalUnreferred": "{count} segnalazioni critiche non trasmesse · {second} verifiche in attesa",
  "overview.headline.approvalsWaiting": "{count} correzioni in attesa · {second} in ritardo",
  "overview.headline.approvalsWaiting.zero": "{count} correzioni in attesa · nulla in ritardo",
  "overview.headline.grantsWithoutExpiry": "{count} accessi senza data di fine · {second} richieste di accesso",
  "overview.headline.incidentsOpen": "{count} incidente aperto · {second} callback falliti",
  "overview.headline.startingAndPayroll": "{count} in arrivo · buste paga aperte",
  "overview.watch.demandOutrunningSupply":
    "I lavori salgono del {first}% e la quota che riceve un preventivo scende di {second} punti. La domanda arriva più in fretta di quanto l'offerta riesca a rispondere.",
  "overview.watch.nobodyAnswered": "{first} lavori sono stati pubblicati senza che nessuno preventivasse.",
  "roles.new.department": "Reparto",
  "roles.new.pickDepartment": "Scegliere un reparto…",
  "roles.new.departmentNeeded":
    "Scelga il reparto del ruolo: un tester QA è Prodotto e tecnologia, un contabile è Finanza.",
  "screen.experiments": "Esperimenti",
  "screen.leads": "Contatti",
  "screen.campaigns": "Campagne",
  "screen.referrals": "Segnalazioni",
  "experiments.title": "Esperimenti",
  "experiments.sub": "Attivare una funzionalità per una parte dei clienti e confrontare.",
  "experiments.loadFailed": "Non è stato possibile caricare gli esperimenti.",
  "experiments.none": "Nessun esperimento.",
  "experiments.start": "Avviare un esperimento",
  "experiments.created": "{reference} creato",
  "experiments.moved": "{reference} al {percent}%",
  "experiments.ship": "Generalizzare",
  "experiments.stop": "Fermare",
  "experiments.sticky": "Una persona resta nel suo gruppo: il gruppo si calcola, non si sorteggia.",
  "experiments.col.name": "Esperimento",
  "experiments.col.feature": "Funzionalità",
  "experiments.col.share": "Quota",
  "experiments.col.status": "Stato",
  "experiments.col.ramp": "Ampliare",
  "experiments.status.draft": "Bozza",
  "experiments.status.running": "In corso",
  "experiments.status.stopped": "Fermato",
  "experiments.status.shipped": "Generalizzato",
  "experiments.startTitle": "Avviare un esperimento",
  "experiments.startBody": "Parte dallo 0%: crearlo e aprirlo sono due decisioni.",
  "experiments.startSubmit": "Creare",
  "experiments.featureNeeded": "Scelga una funzionalità cliente.",
  "experiments.pickFeature": "Scegliere…",
  "experiments.field.name": "Che cosa si prova",
  "experiments.field.feature": "Funzionalità cliente",
  "experiments.field.featureHint": "Un esperimento riguarda i clienti, mai il personale.",
  "experiments.field.metric": "Che cosa si misura",
  "experiments.field.metricHint": "Letto da una persona, non dal codice.",
  "leads.title": "Contatti",
  "leads.sub": "Professionisti che vogliamo e non abbiamo ancora.",
  "leads.loadFailed": "Non è stato possibile caricare i contatti.",
  "leads.none": "Nessun contatto.",
  "leads.add": "Aggiungere un contatto",
  "leads.added": "{name} aggiunto",
  "leads.moved": "{name} aggiornato",
  "leads.markContacted": "Contattato",
  "leads.markLost": "Perso",
  "leads.nameNeeded": "Indichi il nome del professionista.",
  "leads.status.new": "Nuovo",
  "leads.status.contacted": "Contattato",
  "leads.status.signed_up": "Iscritto",
  "leads.status.lost": "Perso",
  "leads.source.coverage_gap": "Mancanza di copertura",
  "leads.source.referral": "Raccomandazione",
  "leads.source.inbound": "In entrata",
  "leads.source.other": "Altro",
  "leads.addTitle": "Aggiungere un contatto",
  "leads.addBody": "Qualcuno che non è ancora sulla piattaforma.",
  "leads.addSubmit": "Aggiungere",
  "leads.field.name": "Nome",
  "leads.field.phone": "Telefono",
  "leads.field.trade": "Mestiere",
  "leads.field.city": "Città",
  "leads.field.source": "Origine",
  "campaigns.title": "Campagne",
  "campaigns.sub": "Messaggi a professionisti e clienti.",
  "campaigns.loadFailed": "Non è stato possibile caricare le campagne.",
  "campaigns.none": "Nessuna campagna.",
  "campaigns.draft": "Preparare una campagna",
  "campaigns.drafted": "{reference} pronta: {count} destinatari",
  "campaigns.send": "Inviare",
  "campaigns.sent": "Inviata a {count} persone",
  "campaigns.wentTo": "È andata a {count}",
  "campaigns.budgetNeeded": "Una campagna SMS ha bisogno di un budget.",
  "campaigns.onlyInactive": "Solo chi non ha fatto nulla",
  "campaigns.inAppFree": "Gratis: la notifica arriva nell'applicazione.",
  "campaigns.smsCosts": "A pagamento: ogni SMS costa, e qui i dati si pagano a ore.",
  "campaigns.smsLength": "{count} caratteri (oltre 160 sono due SMS a persona)",
  "campaigns.channel.in_app": "Nell'applicazione",
  "campaigns.channel.sms": "SMS",
  "campaigns.audience.pros": "Professionisti",
  "campaigns.audience.customers": "Clienti",
  "campaigns.draftTitle": "Preparare una campagna",
  "campaigns.draftBody": "Il numero di destinatari viene ricontato all'invio.",
  "campaigns.draftSubmit": "Preparare",
  "campaigns.field.name": "Nome",
  "campaigns.field.channel": "Canale",
  "campaigns.field.audience": "Destinatari",
  "campaigns.field.body": "Messaggio",
  "campaigns.field.bodyHint": "In francese, visibile a tutti.",
  "campaigns.field.budget": "Budget (GNF)",
  "campaigns.field.budgetHint": "Quanto si autorizza a spendere.",
  "referrals.title": "Segnalazioni",
  "referrals.sub": "Professionisti portati da altri professionisti.",
  "referrals.loadFailed": "Non è stato possibile caricare le segnalazioni.",
  "referrals.none": "Nessuna segnalazione.",
  "referrals.unused": "Codice non usato",
  "referrals.paidOut": "{amount} {currency} versati",
  "referrals.paidWhen": "Versato quando il professionista segnalato ottiene il primo lavoro.",
  "referrals.status.open": "Aperto",
  "referrals.status.signed_up": "Iscritto",
  "referrals.status.rewarded": "Versato",
  "referrals.status.expired": "Scaduto",
  "screen.incidents": "Incidenti",
  "incidents.title": "Incidenti",
  "incidents.sub": "Che cosa è rotto, e che cosa viene detto alle persone.",
  "incidents.loadFailed": "Non è stato possibile caricare gli incidenti.",
  "incidents.openOne": "Aprire un incidente",
  "incidents.happeningNow": "In corso",
  "incidents.allWell": "Funziona tutto.",
  "incidents.over": "Conclusi",
  "incidents.open": "Aprire",
  "incidents.notAnnounced": "Non annunciato",
  "incidents.started": "Iniziato il {when}",
  "incidents.opened": "{reference} aperto",
  "incidents.updated": "{reference} aggiornato",
  "incidents.status.open": "Aperto",
  "incidents.status.monitoring": "Sotto osservazione",
  "incidents.status.resolved": "Risolto",
  "incidents.severity.degraded": "Degradato",
  "incidents.severity.down": "Fuori servizio",
  "incidents.openTitle": "Aprire un incidente",
  "incidents.openBody":
    "Finché resta aperto, ogni cliente vede un avviso. Lasciare vuoto per seguire l'incidente senza annunciare nulla.",
  "incidents.openSubmit": "Aprire",
  "incidents.titleNeeded": "Dica che cosa è rotto, in poche parole.",
  "incidents.causeNeeded": "Dica perché è successo prima di chiudere.",
  "incidents.updateSubmit": "Salvare",
  "incidents.field.title": "Che cosa è rotto",
  "incidents.field.severity": "Gravità",
  "incidents.field.banner": "Messaggio ai clienti",
  "incidents.field.bannerHint": "In francese, visibile a tutti. Vuoto: nessuno viene avvisato.",
  "incidents.field.status": "Stato",
  "incidents.field.note": "Nota",
  "incidents.field.noteHint": "Va nella cronologia, che nulla può riscrivere.",
  "incidents.field.cause": "Causa",
  "screen.overview": "Panoramica",
  "overview.sub": "Che cosa la aspetta oggi.",
  "overview.loadFailed": "Non è stato possibile caricare la panoramica.",
  "overview.needsYou": "Che cosa ha bisogno di lei",
  "overview.nothingToShow": "Niente da mostrare: non possiede nulla di ciò che questo reparto consulta.",
  "overview.waitingDays": "{days} g di attesa",
  "overview.figure.leaveToDecide": "Ferie da decidere",
  "overview.figure.reviewsOwed": "Valutazioni da scrivere",
  "overview.figure.openRoles": "Posizioni aperte",
  "overview.figure.startingSoon": "Ingressi questa settimana",
  "overview.figure.payrollOpen": "Buste paga aperte",
  "overview.figure.leaversStillHolding": "Usciti che hanno ancora accesso",
  "overview.figure.accessRequests": "Richieste di accesso",
  "overview.figure.grantsWithoutExpiry": "Accessi senza data di fine",
  "overview.figure.rolesHeldByNobody": "Ruoli che nessuno ha",
  "overview.figure.staffWithSignIn": "Dipendenti attivi",
  "overview.figure.casesBreaching": "Pratiche quasi scadute",
  "overview.figure.casesMine": "Le sue pratiche",
  "overview.figure.casesUnclaimed": "Pratiche senza titolare",
  "overview.figure.casesOpen": "Pratiche aperte",
  "overview.figure.criticalUnreferred": "Segnalazioni critiche non trasmesse",
  "overview.figure.verificationsWaiting": "Verifiche in attesa",
  "overview.figure.verificationsOverADay": "In attesa da più di 24 h",
  "overview.figure.reportsOpen": "Segnalazioni aperte",
  "overview.figure.restrictionsToReview": "Restrizioni da rivedere",
  "overview.figure.legalHolds": "Blocchi legali",
  "overview.figure.approvalsWaiting": "Correzioni da approvare",
  "overview.figure.feesThisMonth": "Pagamenti questo mese",
  "overview.figure.creditsOutstanding": "Crediti in essere",
  "overview.figure.subscriptionsEndingSoon": "Abbonamenti in scadenza entro 7 g",
  "overview.figure.providerEventsFailed": "Richiami del fornitore falliti",
  "overview.figure.rulesScheduled": "Regole programmate",
  "overview.figure.featureExceptions": "Eccezioni di funzionalità",
  "overview.figure.prosSignedUp": "Professionisti iscritti (30 g)",
  "overview.figure.prosApproved": "Professionisti approvati (30 g)",
  "overview.figure.prosNeverQuoted": "Professionisti che non hanno mai risposto",
  "overview.figure.prosWithWork": "Professionisti con lavoro",
  "overview.figure.promosRunning": "Promozioni in corso",
  "overview.figure.jobsThisMonth": "Richieste questo mese",
  "overview.figure.customers": "Account clienti",
  "overview.item.caseDueOwned": "La sua pratica sta scadendo",
  "overview.item.caseDueUnclaimed": "Pratica senza titolare in scadenza",
  "screen.marketplaceOverview": "Panoramica",
  "screen.jobs": "Richieste",
  "screen.providers": "Professionisti",
  "screen.categories": "Mestieri",
  "screen.marketplaceReviews": "Recensioni",
  "marketplace.title": "Il mercato",
  "marketplace.sub": "Che cosa è stato chiesto, chi sa farlo, e dove nessuno lo sa.",
  "marketplace.loadFailed": "Non è stato possibile caricare il mercato.",
  "marketplace.posted": "Richieste pubblicate",
  "marketplace.gotQuote": "Con preventivo",
  "marketplace.accepted": "Accettate",
  "marketplace.noBids": "Nessuno ha risposto",
  "marketplace.toFirstQuote": "Al 1° preventivo",
  "marketplace.hoursShort": "{hours} h",
  "marketplace.nobodyBid": "Nessuno ha risposto a queste",
  "marketplace.nobodyBidHint": "Le più vecchie per prime.",
  "marketplace.allAnswered": "Tutto ciò che è stato pubblicato ha avuto risposta.",
  "marketplace.waitingDays": "{days} g di attesa",
  "marketplace.noProHere": "qui nessuno lo sa fare",
  "marketplace.prosNearby": "{count} professionisti vicini",
  "marketplace.demandNoSupply": "Domanda senza offerta",
  "marketplace.demandNoSupplyHint": "Chiesto negli ultimi 30 giorni, senza professionisti sul posto.",
  "marketplace.everywhereCovered": "Ogni città ha professionisti per ciò che chiede.",
  "marketplace.activePros": "{count} professionisti possono lavorare oggi",
  "marketplace.jobs": "Richieste",
  "marketplace.jobsSub": "Ogni richiesta, e fin dove è arrivata.",
  "marketplace.noJobs": "Nessuna richiesta corrisponde.",
  "marketplace.filter.all": "Tutte",
  "marketplace.filter.no_quotes": "Senza preventivo",
  "marketplace.filter.requested": "Pubblicate",
  "marketplace.filter.quoted": "Con preventivo",
  "marketplace.filter.accepted": "Accettate",
  "marketplace.filter.cancelled": "Annullate",
  "marketplace.status.requested": "Pubblicata",
  "marketplace.status.quoted": "Con preventivo",
  "marketplace.status.accepted": "Accettata",
  "marketplace.status.cancelled": "Annullata",
  "marketplace.status.declined": "Rifiutata",
  "marketplace.status.expired": "Scaduta",
  "marketplace.col.job": "Richiesta",
  "marketplace.col.city": "Città",
  "marketplace.col.posted": "Pubblicata",
  "marketplace.col.quotes": "Preventivi",
  "marketplace.col.estimate": "Stima",
  "marketplace.col.status": "Stato",
  "marketplace.providers": "Professionisti",
  "marketplace.providersSub": "Chi può lavorare, e chi non lavora ancora.",
  "marketplace.noPros": "Nessun professionista corrisponde.",
  "marketplace.neverQuoted": "Mai risposto",
  "marketplace.allPros": "Tutti",
  "marketplace.unverified": "Non verificato",
  "marketplace.col.pro": "Professionista",
  "marketplace.col.skills": "Mestieri",
  "marketplace.col.quotesGiven": "Preventivi dati",
  "marketplace.col.rating": "Valutazione",
  "marketplace.categories": "Mestieri",
  "marketplace.categoriesSub": "Che cosa viene chiesto, e se qualcuno sa farlo.",
  "marketplace.noCategories": "Nessun mestiere da mostrare.",
  "marketplace.noDemand": "Nessuna domanda",
  "marketplace.coverageHint": "La copertura è la quota di richieste con almeno un preventivo.",
  "marketplace.col.category": "Mestiere",
  "marketplace.col.jobs": "Richieste",
  "marketplace.col.pros": "Professionisti",
  "marketplace.col.coverage": "Copertura",
  "marketplace.col.uncovered": "Città senza professionisti",
  "marketplace.reviews": "Recensioni",
  "marketplace.reviewsSub": "Che cosa dicono i clienti dei professionisti.",
  "marketplace.noReviews": "Nessuna recensione corrisponde.",
  "marketplace.poorOnly": "3 stelle o meno",
  "marketplace.allReviews": "Tutte",
  "marketplace.averageIs": "Media {average} su {total} recensioni",
  "nav.group.everyone": "Tutti",
  "workspace.yours": "I suoi spazi",
  "department.executive": "Direzione",
  "department.executive.blurb": "L'azienda a colpo d'occhio",
  "department.marketplace": "Operazioni del mercato",
  "department.marketplace.blurb": "Richieste, professionisti, categorie",
  "department.support": "Assistenza clienti",
  "department.support.blurb": "Pratiche, clienti e professionisti",
  "department.trust": "Fiducia e sicurezza",
  "department.trust.blurb": "Verifiche, segnalazioni, restrizioni",
  "department.finance": "Finanza",
  "department.finance.blurb": "Commissioni, correzioni, abbonamenti",
  "department.growth": "Vendite e crescita",
  "department.growth.blurb": "Reclutare professionisti, promozioni",
  "department.product": "Prodotto e tecnologia",
  "department.product.blurb": "Incidenti, regole, rilasci",
  "department.people": "Risorse umane",
  "department.people.blurb": "Assunzioni, impiego, buste paga",
  "department.administration": "Amministrazione e sicurezza",
  "department.administration.blurb": "Ruoli, permessi, registro",
  "department.legal": "Legale e conformità",
  "department.legal.blurb": "Condizioni, dati, richieste legali",
  "nav.signedInAs": "Connesso come",
  "nav.screenCount": "{roles} · {visible} schermate su {total}",
  "profile.title": "Il tuo profilo",
  "profile.open": "Apri il tuo profilo",
  "profile.identity": "Tu",
  "profile.email": "E-mail",
  "profile.roles": "Ruoli",
  "profile.permits": "Cosa ti permettono i tuoi ruoli",
  "profile.screensOpen": "{visible} di {total} schermate aperte",
  "profile.actionCount": "{count} azioni disponibili",
  "profile.noPermissions": "Nessun permesso con limite: nulla richiede approvazione.",
  "profile.preferences": "Preferenze",
  "profile.emailLabel": "E-mail:",
  "profile.uuidLabel": "UUID:",
  "profile.rolesLabel": "Ruoli",
  "profile.figure.screens": "schermate aperte per te",
  "profile.figure.actions": "azioni che puoi fare",
  "profile.figure.ceilings": "con un tetto",
  "profile.ceilingHeading": "Il massimo che puoi fare da solo",
  "profile.ceilingHint":
    "Oltre un tetto l'azione si apre comunque: il tuo tentativo diventa una richiesta di approvazione.",
  "profile.signOutHint": "Dovrai accedere di nuovo.",
  "header.signOut": "Esci",
  "header.signingOut": "Uscita…",
  "header.language": "Lingua della console",
  "header.theme": "Tema",
  "header.theme.system": "Sistema",
  "header.theme.light": "Chiaro",
  "header.theme.dark": "Scuro",
  "header.languageNotSaved": "Solo per questa sessione: la scelta non è ancora salvata nel tuo account.",
  "shell.loading": "Caricamento della console…",
  "shell.loadFailed": "Impossibile caricare il tuo profilo",
  "shell.retry": "Riprova",
  "shell.refreshFailed":
    "Non è stato possibile aggiornare i tuoi permessi. La console mostra quelli caricati alle {time}.",
  "shell.noScreens": "Nessuna schermata è disponibile per i tuoi ruoli ({roles}). Chiedi l'accesso a un responsabile.",
  "shell.noRoles": "Non hai ancora nessuna schermata accessibile. Chiedi un ruolo a un responsabile.",
  "connection.retrying": "Connessione instabile · nuovo tentativo {attempt} di {max}…",

  // ── Screens ──
  "screen.dashboard": "Dashboard",
  "screen.myRequests": "Le mie richieste",
  "screen.myTimeOff": "Le mie ferie",
  "myTimeOff.sub": "Il tuo saldo, cosa hai chiesto, e chi altro è assente.",
  "myRequests.sub": "Cosa hai chiesto di poter fare, e a che punto è ogni risposta.",
  "screen.as.directory": "Rubrica",
  "screen.as.market": "Mercato",
  "screen.as.employees": "Dipendenti",
  "screen.as.recruiting": "Selezione",
  "screen.as.learning": "Formazione",
  "screen.as.payroll": "Buste paga",
  "screen.as.money": "Denaro",
  "screen.as.workforce": "Personale",
  "screen.as.accounts": "Account",
  "screen.cases": "Pratiche",
  "screen.customers": "Clienti e pro",
  "screen.verifications": "Verifiche",
  "screen.reports": "Segnalazioni",
  "screen.billing": "Prezzi e abbonamenti",
  "screen.payments": "Pagamenti",
  "screen.features": "Attivazioni funzionalità",
  "screen.userSettings": "Impostazioni utente",
  "settings.title": "Impostazioni utente",
  "settings.tab.app": "Utente dell'app",
  "settings.tab.employee": "Dipendente",
  "settings.col.setting": "Impostazioni",
  "settings.default": "Valore predefinito",
  "settings.setHere": "Impostato per questa persona",
  "settings.clear": "Cancella",
  "settings.none": "Nessuna impostazione corrisponde.",
  "screen.actions": "Azioni",
  "actions.title": "Azioni",
  "actions.col.action": "Azione",
  "actions.effect.read": "Lettura",
  "actions.effect.write": "Scrittura",
  "actions.alsoGates": "+{count} altre",
  "actions.col.area": "Area",
  "actions.col.effect": "Effetto",
  "actions.col.audited": "Auditata",
  "actions.col.needs": "Richiede",
  "actions.needs.nothing": "Niente",
  "actions.yes": "Sì",
  "actions.no": "No",
  "actions.surface.system": "Sistema",
  "actions.search": "Cercare un'azione",
  "actions.none": "Nessuna azione corrisponde.",
  "screen.permissions": "Permessi",
  "permissions.title": "Permessi",
  "permissions.tab.role": "Ruolo",
  "permissions.tab.employee": "Dipendente",
  "permissions.col.limit": "Limite",
  "permissions.col.expires": "Scade",
  "permissions.source.staffRole": "Per ruolo",
  "permissions.source.staffMember": "Deroga",
  "permissions.source.allStaff": "Tutto il personale",
  "permissions.source.default": "Nessuno",
  "permissions.noLimit": "Nessun tetto",
  "permissions.featureOff": "Funzionalità disattivata",
  "permissions.approvable": "Può chiedere",
  "permissions.pickRole": "Scelga un ruolo",
  "audit.kind.featureEnablements": "Attivazioni funzionalità",
  "audit.kind.permissions": "Permessi",
  "audit.kind.teams": "Ruoli e team",
  "audit.kind.actions": "Azioni",
  "audit.kind.userSettings": "Impostazioni utente",
  "screen.roles": "Ruoli",
  "roles.title": "Ruoli",
  "roles.grants.none": "Non concede ancora nulla",
  "roles.grants.permissions": "Modificare i permessi",
  "roles.grants.features": "Modificare le funzionalità",
  "roles.explain":
    "Ciò che una persona sa e può fare. Un ruolo è lo stesso in ogni team: guidarlo non è un ruolo, si imposta in Team.",
  "roles.col.name": "Ruolo",
  "roles.col.description": "Che cosa copre",
  "roles.col.members": "Persone",
  "roles.none": "Ancora nessun ruolo.",
  "roles.loading": "Caricamento dei ruoli…",
  "roles.loadFailed": "Non è stato possibile leggere i ruoli.",
  "roles.retry": "Riprova",
  "roles.edit": "Rinomina",
  "roles.save": "Salva",
  "roles.cancel": "Annulla",
  "roles.created": "Ruolo creato.",
  "roles.new": "Nuovo ruolo",
  "roles.new.title": "Nuovo ruolo",
  "roles.back": "← Tutti i ruoli",
  "roles.opens": "Che cosa apre",
  "roles.opens.explain":
    "Le schermate che questo ruolo raggiunge, dalle caselle a sinistra. Non un elenco a parte: una schermata appare perché il ruolo ha ciò che serve, e l'API controlla lo stesso.",
  "roles.new.name": "Nome",
  "roles.new.description": "Che cosa copre",
  "roles.new.create": "Crea il ruolo",
  "roles.new.nameNeeded": "Dai un nome al ruolo.",
  "roles.new.grantsNeeded": "Scegli a cosa serve il ruolo: un ruolo che non concede nulla non ha effetto.",
  "roles.new.grants": "Che cosa può usare",
  "roles.new.permissions": "Che cosa può fare",
  "roles.lock.critical": "Solo un Owner può concederlo.",
  "roles.lock.high": "Puoi concedere solo ciò che hai tu stesso.",
  "roles.lock.readOnly": "Non puoi concedere su un ruolo.",
  "roles.lock.featureFirst": "Attiva prima ciò su cui si basa.",
  "screen.teams": "Team",
  "teams.title": "Team",
  "teams.col.name": "Team",
  "teams.col.purpose": "A cosa serve",
  "teams.col.lead": "Guidato da",
  "teams.col.members": "Persone",
  "teams.col.status": "Stato",
  "teams.col.person": "Persona",
  "teams.col.roles": "Ruolo",
  "teams.col.onTeam": "Nel team",
  "teams.col.leads": "Lo guida",
  "teams.open": "Apri",
  "teams.back": "Tutti i team",
  "teams.none": "Ancora nessun team.",
  "teams.noMembers": "Non c'è ancora nessuno in questo team.",
  "teams.noOthers": "Sono già tutti in questo team.",
  "teams.loading": "Caricamento dei team…",
  "teams.loadFailed": "Non è stato possibile leggere i team.",
  "teams.retry": "Riprova",
  "teams.status.open": "Aperto",
  "teams.status.closed": "Chiuso",
  "teams.rename": "Rinomina",
  "teams.close": "Chiudere il team",
  "teams.reopen": "Riaprirlo",
  "teams.closedReason": "Chiuso",
  "teams.reopenedReason": "Riaperto",
  "teams.closedNote": "Chiuso. Tutti restano dentro: riaprendolo sono ancora lì.",
  "teams.new": "Nuovo team",
  "teams.explain":
    "Un gruppo di persone che fanno lo stesso tipo di lavoro, con un responsabile. Il lavoro va al team, non a una persona: chi è di turno oggi prende il successivo. Un team non concede nulla.",
  "teams.new.people":
    "Chi ne fa parte fin da quando esiste. Spunta “Lo guida” per dire di chi sono queste persone: riassegna il lavoro del team e sostituisce chiunque.",
  "teams.new.name": "Nome",
  "teams.new.purpose": "A cosa serve",
  "teams.new.create": "Crea il team",
  "teams.new.cancel": "Annulla",
  "teams.new.nameNeeded": "Dai un nome al team.",
  "teams.nameTaken": "Esiste già un team con questo nome.",
  "teams.created": "Team creato.",
  "teams.leadHint": "Sono le sue persone: riassegna il lavoro del team e sostituisce chiunque.",
  "teams.leadNeedsMember": "Si può guidare solo un team di cui si fa parte.",
  "teams.noLead": "Senza responsabile",
  "teams.gone": "Chi è uscito non può essere inserito in un team.",
  "teams.locked": "Non puoi modificare i team.",
  "screen.rules": "Regole",
  "screen.hr": "Risorse umane",
  "sub.hr": "Cerca chiunque. Selezione, fascicoli e tutto ciò che sta sotto sono delle risorse umane.",
  "screen.team": "Ruoli e team",
  "screen.audit": "Audit Walliyo",

  // ── Locked screen (opened by URL without the feature) ──
  "lock.requires": "Questa schermata richiede",
  "lock.or": " o ",
  "lock.roles": "I tuoi ruoli ({roles}) non la includono, quindi non compare nel tuo menu.",
  "lock.noRoles": "Non hai alcun ruolo, quindi non compare nel tuo menu.",

  // ── Sign-in ──
  "signIn.title": "Accesso alla console",
  "signIn.subtitle": "Riservato al team Walliyo. Riceverai un codice via SMS.",
  "signIn.email": "Email di lavoro",
  "signIn.password": "Password",
  "signIn.submit": "Continua",
  "signIn.submitting": "Verifica…",
  "verify.title": "Codice di verifica",
  "verify.subtitle": "Abbiamo inviato un codice via SMS al {phone}.",
  "verify.code": "Codice ricevuto via SMS",
  "verify.submit": "Accedi",
  "verify.submitting": "Verifica…",
  "verify.expiresIn": "Il codice scade tra {time}.",
  "verify.expired": "Il codice è scaduto. Ricomincia l'accesso per riceverne uno nuovo.",
  "verify.restart": "Ricomincia l'accesso",

  // ── Errors: what failed and what to do (ADR-0016 §2.5) ──
  "error.requestId": "ID richiesta: {id}",
  "error.noRequestId": "Nessun ID richiesta: il server non ha risposto.",
  "error.signIn.unauthenticated": "Email o password errate. Controllale e riprova.",
  "error.signIn.validation_error": "Inserisci un'email e una password valide.",
  "error.verify.validation_error": "Inserisci il codice di 6 cifre ricevuto via SMS.",
  "error.verify.session_expired": "Il codice è scaduto. Ricomincia l'accesso per riceverne uno nuovo.",
  "error.verify.unauthenticated": "Questa richiesta di codice non è più valida. Ricomincia l'accesso.",
  "error.unauthenticated": "Non sei più connesso. Accedi di nuovo.",
  "error.session_expired": "La tua sessione è scaduta. Accedi di nuovo.",
  "error.feature_not_enabled": "I tuoi ruoli non consentono questa azione. Chiedi l'accesso a un responsabile.",
  "error.invalid_code": "Codice errato. Controlla l'SMS e inserisci di nuovo il codice.",
  "error.too_many_attempts": "Troppi tentativi. Attendi qualche minuto, poi ricomincia l'accesso.",
  "error.stale_version":
    "Questo elemento è cambiato mentre lo stavi guardando. Ricarica per vedere la versione attuale.",
  "error.validation_error": "Alcune informazioni non sono valide. Correggile e riprova.",
  "error.internal_error":
    "Il server ha riscontrato un errore. Riprova; se continua, comunica l'ID qui sotto al team tecnico.",
  "error.network_error": "Nessuna risposta dal server dopo diversi tentativi. Controlla la connessione, poi riprova.",
  "error.network_error.write":
    "Nessuna risposta dal server: la richiesta potrebbe essere andata a buon fine. Riprova, non verrà eseguita due volte.",
  "error.unexpected_response":
    "Risposta inattesa dal server. Riprova; se continua, comunica l'ID qui sotto al team tecnico.",
  "error.unknown":
    "Si è verificato un errore imprevisto nella console. Ricarica la pagina; se continua, avvisa il team tecnico.",

  "sub.cases": "Coda condivisa · chiamate, email e chat nello stesso posto",

  "sub.customers": "Cercare un cliente o un pro e vedere tutto il suo account",

  "sub.verifications": "Verificare l'identità dei pro prima che possano essere trovati",

  "sub.reports": "Segnalazioni su pro o clienti, per gravità",

  "sub.billing": "Prezzi per paese, promozioni e sconti · il professionista mantiene il prezzo con cui si è abbonato",
  "sub.payments": "Commissioni dei pro · Orange Money e carta",

  "sub.features": "Abilitare o disabilitare per livello: tutti, una regione, una versione, una persona",

  "sub.rules": "Valori aziendali · ogni modifica crea una versione",

  // ── Fonctionnalités ──
  "features.title": "Attivazioni funzionalità",
  "features.loading": "Caricamento delle funzionalità…",
  "features.loadFailed": "Impossibile caricare le funzionalità.",
  "features.retry": "Riprova",
  "features.close": "Chiudi",
  "features.pick": "Scegli una funzionalità per vederne le eccezioni.",
  "features.notFound": "Questa funzionalità non esiste o non esiste più. Scegline una dall'elenco.",
  "features.subject.for": "Record",
  "features.subject.allClients": "Tutti i clienti",
  "features.subject.allPros": "Tutti i pro",
  "features.subject.user": "Utente",
  "features.subject.uuid": "UUID",
  "features.subject.uuidHint": "31290388",
  "features.subject.unknown": "UUID non trovato.",
  "features.kind.client": "Cliente",
  "features.kind.pro": "Pro",
  "features.col.source": "Origine",
  "features.col.value": "Valore",
  "features.col.category": "Categoria",
  "features.value.on": "Attivo",
  "features.value.off": "Disattivo",
  "features.source.default": "Predefinito",
  "features.source.thisUser": "Questo utente",
  "features.source.user": "Un utente",
  "features.source.allClients": "Tutti i clienti",
  "features.source.allPros": "Tutti i pro",
  "features.source.proProfile": "Profilo pro",
  "features.source.region": "Regione",
  "features.source.appVersion": "Versione dell'app",
  "features.source.system": "Sistema",
  "features.locked.owner": "Solo un Owner può modificarlo",
  "features.locked.scope": "Non impostabile a questo livello",
  "features.save.discard": "Annulla",
  "features.save.sending": "Salvataggio…",
  "features.save.nothing": "Niente da salvare: nessuna modifica.",
  "features.save.locked": "Una delle modifiche non le spetta.",
  "features.save.reasonNeeded": "Dica perché, in poche parole.",
  "features.save.leave": "Ha modifiche non salvate.",
  "features.clear": "Tornare al valore ereditato",
  "features.cleared": "Sarà cancellato",
  "features.filter.any": "Tutte",
  "features.filter.own": "Impostata qui",
  "features.filter.inherited": "Ereditata",
  "features.filter.search": "Cerca",
  "features.filter.none": "Nessuna funzionalità corrisponde a questi filtri.",
  "features.surface.app": "App Walliyo",
  "features.surface.console": "Console Walliyo",
  "features.save.title.one": "1 modifica non salvata",
  "features.save.title.many": "{count} modifiche non salvate",
  "features.save.submit.one": "Salva 1 modifica",
  "features.save.submit.many": "Salva {count} modifiche",
  "features.save.done.one": "1 modifica salvata.",
  "features.save.done.many": "{count} modifiche salvate.",
  "features.unsaved": "non salvata",
  "features.surface.consoleSoon":
    "Le {count} funzionalità della console si impostano ancora solo per ruolo. Per persona arriva qui.",
  "features.surface.consoleWhere": "Apri Ruoli e team",
  "features.subject.isStaff":
    "Quel numero appartiene a un dipendente Walliyo. Le sue funzionalità sono nella scheda Console Walliyo.",
  "features.subject.search": "Cerca",
  "features.subject.searching": "Ricerca…",
  "features.subject.needsUuid": "Digiti le otto cifre dell'UUID.",
  "features.subject.pickFirst": "Scelga per chi, poi cerchi.",
  "features.subject.stale": "Questi risultati sono della ricerca precedente. Cerchi di nuovo per aggiornarli.",
  "features.pill.allClients": "Tutti i record cliente",
  "features.pill.allPros": "Tutti i record pro",
  "features.pill.unknown": "Utente sconosciuto",
  "features.pill.staff": "Dipendente Walliyo",
  "features.subject.allStaff": "Tutto il personale",
  "features.subject.staffMember": "Dipendente",
  "features.staffSource.override": "Deroga",
  "features.staffSource.byRole": "Per ruolo",
  "features.staffSource.byRoleNamed": "Per ruolo: {roles}",
  "features.staffSource.allStaff": "Tutto il personale",
  "features.locked.ownAccount": "Non può modificare il proprio account",
  "features.locked.grant": "Non può concedere questa",
  "features.pill.allStaff": "Tutti i record del personale",
  "features.pill.unknownStaff": "Dipendente sconosciuto",
  "features.subject.isCustomer":
    "Quel numero appartiene a un cliente, non a un dipendente. Le sue funzionalità sono nella scheda App Walliyo.",
  "features.subject.employeeUuid": "UUID del dipendente",
  "features.subject.staffUuidHint": "27217102",
  "features.col.feature": "Funzionalità",
  "features.col.default": "Predefinito",
  "features.col.exceptions": "Eccezioni",
  "features.for.clients": "Per i clienti",
  "features.for.pros": "Per i pro",
  "features.for.everyone": "Per tutti",
  "features.on": "Attiva",
  "features.off": "Disattiva",
  "features.planned": "Prevista",
  "features.planned.note": "Prevista: si può impostare un valore, ma nessun codice lo legge ancora.",
  "features.detail.default": "Predefinito: {value}",
  "features.sensitivity.open": "Sensibilità {level}: chiunque gestisca le funzionalità dell'app può modificarla.",
  "features.sensitivity.critical":
    "Sensibilità critica: solo un proprietario può modificarla, e i proprietari vengono avvisati.",
  "features.locked.critical":
    "Bloccata: questa funzionalità è critica e solo un proprietario può modificarla. I tuoi ruoli ({roles}) non ti rendono proprietario; anche il server rifiuterebbe.",
  "features.exceptions.title": "Eccezioni per livello",
  "features.col.scope": "Livello",
  "features.col.target": "Destinatario",
  "features.col.reason": "Motivo",
  "features.col.expires": "Scade",
  "features.col.actions": "Gestisci",
  "features.default.scope": "Predefinito",
  "features.default.reason": "valore predefinito",
  "features.exceptions.none": "Nessuna eccezione: il valore predefinito vale per tutti.",
  "features.expired": "Scaduta",
  "features.expires.never": "Fino a modifica",
  "features.edit": "Modifica",
  "features.remove": "Rimuovi",
  "features.add": "Aggiungi un'eccezione",
  "features.scope.system": "Sistema",
  "features.scope.allClients": "Tutti i clienti",
  "features.scope.allPros": "Tutti i pro",
  "features.scope.region": "Regione",
  "features.scope.appVersion": "Versione dell'app",
  "features.scope.user": "Una persona",
  "features.scope.proProfile": "Un profilo pro",
  "features.scope.clientProfile": "Un profilo cliente",
  "features.target.everyone": "Tutti",
  "features.target.allClients": "Tutti i clienti",
  "features.target.allPros": "Tutti i pro",
  "features.target.appVersion": "Versione {version} e successive",
  "features.target.unnamed": "Account senza nome",
  "features.form.addTitle": "Nuova eccezione",
  "features.form.editTitle": "Modifica l'eccezione",
  "features.form.scope": "Livello",
  "features.form.scopePick": "Scegli un livello…",
  "features.form.scopeUnsupported": "{scope} (non ancora possibile)",
  "features.form.clientProfileNote":
    "Un profilo cliente non può ancora ricevere un valore: i profili cliente non esistono ancora. Per un cliente, scegli «Una persona».",
  "features.form.needsSearch": "Scegliere una persona o un profilo pro richiede",
  "features.form.needsView": "Trovare il profilo pro di un account richiede",
  "features.form.region": "Regione",
  "features.form.regionPick": "Scegli una regione…",
  "features.form.appVersion": "Dalla versione",
  "features.form.appVersionHint": "Ad esempio 2.4.0: vale per quella versione e le successive.",
  "features.form.person": "Persona",
  "features.form.pro": "Profilo pro",
  "features.form.search": "Cerca",
  "features.form.searching": "Ricerca…",
  "features.form.searchPlaceholder": "Nome, telefono, email o ID account",
  "features.form.noResults": "Nessun account corrisponde.",
  "features.form.pickedChange": "Cambia",
  "features.form.value": "Valore",
  "features.form.reason": "Motivo (obbligatorio)",
  "features.form.reasonHint": "Viene registrato nel registro di audit con la modifica.",
  "features.form.expires": "Scade il",
  "features.form.expiresHint": "Facoltativo. Vuoto: fino a modifica.",
  "features.form.version": "Basata sulla versione {version} di questa eccezione.",
  "features.form.submitAdd": "Aggiungi l'eccezione",
  "features.form.submitEdit": "Salva",
  "features.form.cancel": "Annulla",
  "features.form.sending": "Invio…",
  "features.problem.scope": "Scegli uno dei livelli proposti.",
  "features.problem.region": "Scegli una regione.",
  "features.problem.appVersion": "Inserisci una versione come 2.4.0.",
  "features.problem.person": "Cerca la persona e sceglila tra i risultati.",
  "features.problem.pro": "Cerca il pro e scegli un account con un profilo pro.",
  "features.problem.exists": "Esiste già un'eccezione per questo destinatario: modificala.",
  "features.problem.reason": "Indica un motivo in poche parole.",
  "features.problem.expiryInvalid": "Questa data di scadenza non è valida.",
  "features.problem.expiryPast": "La data di scadenza deve essere nel futuro, oppure lasciala vuota.",
  "features.refused.critical": "Rifiutato: questa funzionalità è critica, solo un proprietario può modificarla.",
  "features.refused.scopeNotSupported":
    "Rifiutato: un profilo cliente non può ancora ricevere un valore, i profili cliente non esistono ancora. Scegli «Una persona».",
  "features.refused.scopeNotAllowed":
    "Rifiutato: questa funzionalità non può essere impostata a quel livello. Scegli uno dei livelli proposti.",
  "features.refused.expiryInPast":
    "Rifiutato: la data di scadenza è passata. Scegli una data successiva, oppure lasciala vuota.",
  "features.refused.targetNotFound": "Rifiutato: quell'account o profilo pro non esiste più. Cercalo di nuovo.",
  "features.stale":
    "Qualcuno ha modificato questa funzionalità nel frattempo. Ricarica per vedere le eccezioni attuali, poi riprova.",
  "features.done.added": "Eccezione aggiunta.",
  "features.done.saved": "Eccezione modificata.",
  "features.done.removed": "Eccezione rimossa: torna a valere il livello più ampio, o il valore predefinito.",
  "features.remove.title": "Rimuovi l'eccezione",
  "features.remove.body":
    "Rimuovere l'eccezione «{scope} · {target}: {value}» da {feature}. Tornerà a valere il livello più ampio, o il valore predefinito.",
  "features.remove.submit": "Rimuovi",

  // ── Règles ──
  "rules.loading": "Caricamento delle regole…",
  "rules.loadFailed": "Impossibile caricare le regole.",
  "rules.retry": "Riprova",
  "rules.pick": "Scegli una regola per vederne la cronologia.",
  "rules.notFound": "Questa regola non esiste. Scegline una dall'elenco.",
  "rules.next": "dal {date}: {value}",
  "rules.now": "In vigore",
  "rules.default": "valore predefinito",
  "rules.kind.gnf": "importo in GNF",
  "rules.kind.minutes": "durata in minuti",
  "rules.kind.hours": "durata in ore",
  "rules.kind.days": "durata in giorni",
  "rules.kind.km": "distanza in km",
  "rules.kind.number": "numero",
  "rules.kind.boolean": "sì o no",
  "rules.kind.choice": "scelta da un elenco",
  "rules.kind.text": "testo",
  "rules.sensitivity.open": "Sensibilità {level}: chiunque possa modificare le regole può creare una versione.",
  "rules.sensitivity.critical": "Sensibilità critica: solo un proprietario può creare una versione.",
  "rules.legalBasis.required": "Ogni modifica deve citare la sua base giuridica.",
  "rules.locked.critical":
    "Bloccata: questa regola è critica, solo un proprietario può creare una versione. I tuoi ruoli ({roles}) non ti rendono proprietario; anche il server rifiuterebbe.",
  "rules.locked.retired": "Questa regola è ritirata: niente la legge più, quindi non può cambiare.",
  "rules.history": "Cronologia delle versioni",
  "rules.history.none": "Nessuna versione: vale il valore predefinito ({value}).",
  "rules.col.version": "N. versione",
  "rules.col.value": "Valore",
  "rules.col.effective": "In vigore",
  "rules.col.reason": "Motivo",
  "rules.col.legalBasis": "Base giuridica",
  "rules.col.by": "Da",
  "rules.status.scheduled": "Dal {date}",
  "rules.status.current": "Attuale",
  "rules.status.since": "dal {date}",
  "rules.status.past": "Sostituita",
  "rules.new": "Nuova versione",
  "rules.form.title": "Nuova versione",
  "rules.form.value": "Nuovo valore",
  "rules.form.value.gnf": "Nuovo importo (GNF)",
  "rules.form.value.minutes": "Nuovo valore (in minuti)",
  "rules.form.value.hours": "Nuovo valore (in ore)",
  "rules.form.value.days": "Nuovo valore (in giorni)",
  "rules.form.effective": "Entrata in vigore",
  "rules.form.now": "Da subito",
  "rules.form.at": "A una data e ora",
  "rules.form.atLabel": "In vigore dal",
  "rules.form.reason": "Motivo (obbligatorio)",
  "rules.form.legalBasis": "Base giuridica (obbligatoria)",
  "rules.form.legalBasisOptional": "Base giuridica (se applicabile)",
  "rules.form.legalBasisPlaceholder": "Legge, contratto, parere legale",
  "rules.form.version":
    "Basata sulla versione {version} della regola: se nel frattempo viene aggiunta un'altra versione, l'invio sarà rifiutato.",
  "rules.form.submit": "Crea la versione",
  "rules.form.cancel": "Annulla",
  "rules.form.sending": "Invio…",
  "rules.value.true": "Sì",
  "rules.value.false": "No",
  "rules.problem.value": "Inserisci un valore.",
  "rules.problem.number": "Inserisci un numero, ad esempio 750000.",
  "rules.problem.integer": "Inserisci un numero intero.",
  "rules.problem.min": "Il valore deve essere almeno {min}.",
  "rules.problem.max": "Il valore deve essere al massimo {max}.",
  "rules.problem.choice": "Scegli un valore dall'elenco.",
  "rules.problem.tooLong": "Al massimo {max} caratteri.",
  "rules.problem.effectiveMissing": "Scegli la data e l'ora di entrata in vigore.",
  "rules.problem.effectivePast":
    "Una versione non può entrare in vigore nel passato: ciò che valeva allora resta agli atti. Scegli adesso o più tardi.",
  "rules.problem.reason": "Indica un motivo in poche parole.",
  "rules.problem.legalBasis": "Cita la legge, il contratto o il parere legale alla base di questa modifica.",
  "rules.refused.critical": "Rifiutato: questa regola è critica, solo un proprietario può creare una versione.",
  "rules.refused.effectivePast": "Rifiutato: quella data è passata. Scegli adesso o più tardi.",
  "rules.refused.legalBasis":
    "Rifiutato: questa regola richiede una base giuridica. Cita la legge, il contratto o il parere legale.",
  "rules.refused.invalidValue": "Rifiutato: quel valore non va bene per la regola. Controlla l'unità e il minimo.",
  "rules.refused.retired": "Rifiutato: questa regola è ritirata, niente la legge più.",
  "rules.stale":
    "Nel frattempo è stata aggiunta un'altra versione di questa regola. Ricarica per vederla, poi riprova.",
  "rules.done.now": "Versione {version} creata: vale da subito.",
  "rules.done.scheduled": "Versione {version} creata: varrà dal {date}.",

  "sub.team": "Ogni ruolo è un elenco di funzionalità. Nessuno può concedere nulla a se stesso.",

  "sub.audit": "Tutto ciò che è stato fatto, da chi, per chi · anche la tua consultazione viene registrata",

  // ── Audit log ──
  "audit.filter.subject": "Persona interessata",
  "audit.filter.subjectPlaceholder": "ID dell'account",
  "audit.filter.staff": "Membro del team",
  "audit.filter.staffPlaceholder": "ID del membro",
  "audit.filter.action": "Azione",
  "audit.filter.area": "Ambito",
  "audit.filter.outcome": "Esito",
  "audit.filter.from": "Dal",
  "audit.filter.to": "Al (incluso)",
  "audit.filter.all": "Tutti",
  "audit.filter.allActions": "Tutte",
  "audit.filter.clear": "Cancella i filtri",
  "audit.problem.id": "Un ID ha la forma 3f2a…-…-…-…-… (UUID). Copialo dalla scheda dell'account.",
  "audit.problem.period": "La fine del periodo è precedente al suo inizio.",
  "audit.problem.needsPerson": "Indichi l'UUID di chi ha modificato, quello della persona, o entrambi.",
  "audit.filtersAria": "Filtri del registro",
  "audit.searchAria": "Ricerca nel registro",
  "audit.scope.user": "Individuo",
  "audit.scope.allStaff": "Tutto il personale",
  "audit.scope.allClients": "Tutti i clienti",
  "audit.scope.allPros": "Tutti i pro",
  "audit.scope.staffRole": "Ruolo",
  "audit.scope.proProfile": "Profilo pro",
  "audit.scope.region": "Regione",
  "audit.scope.appVersion": "Versione dell'app",
  "audit.scope.system": "Sistema",
  "audit.scope.staffMember": "Individuo",
  "audit.filter.involving": "Coinvolge",
  "audit.filter.updaterUuid": "UUID di chi ha modificato",
  "audit.filter.userUuid": "UUID della persona",
  "audit.pill.updater": "Autore",
  "audit.pill.user": "Persona",
  "audit.col.time": "Ora",
  "audit.col.actor": "Autore",
  "audit.col.action": "Impostazione",
  "audit.col.subject": "Riguarda",
  "audit.col.outcome": "Esito",
  "audit.col.reason": "Motivo",
  "audit.filter.effect": "Mostra",
  "audit.effect.write": "Modifiche",
  "audit.effect.read": "Consultazioni",
  "audit.col.before": "Prima",
  "audit.col.after": "Dopo",
  "audit.change.arrow": "{before} → {after}",
  "audit.change.field": "{key}: {value}",
  "audit.outcome.succeeded": "Riuscito",
  "audit.outcome.denied": "Negato",
  "audit.outcome.requested": "Richiesto",
  "audit.actor.staff": "Membro del team",
  "audit.actor.noRoles": "nessun ruolo",
  "audit.actor.customer": "cliente",
  "audit.actor.self": "cliente (se stesso)",
  "audit.actor.system": "Sistema",
  "audit.subject.onBehalf": "per conto di {id}",
  "audit.filterBy": "Filtra per {id}",
  "audit.subject.open": "Apri l'account di {name}",
  "audit.masked": "nascosto",
  "audit.sensitive": "🔒 sensibile",
  "audit.loading": "Caricamento del registro…",
  "audit.loadFailed": "Non è stato possibile caricare il registro.",
  "audit.retry": "Riprova",
  "audit.empty": "Nessuna voce corrisponde a questi filtri.",
  "audit.emptyForPerson": "Nessuna voce per questa ricerca.",
  "audit.fixProblems": "Correggi i filtri segnalati per mostrare il registro.",
  "audit.loadMore": "Carica altro",
  "audit.loadingMore": "Caricamento…",
  "audit.moreFailed": "Non è stato possibile caricare la pagina successiva. Le voci già mostrate restano valide.",
  "audit.count": "{count} voci mostrate",
  "audit.countOne": "1 voce mostrata",
  "audit.end": "Fine del registro per questi filtri.",
  "audit.recorded": "Anche la tua consultazione viene registrata (VIEW_AUDIT_LOG_STAFF_ACTION), con i filtri usati.",
  "audit.sensitiveShown": "Vedi i valori sensibili (VIEW_SENSITIVE_AUDIT_VALUES).",
  "audit.sensitiveHidden":
    "I valori sensibili sono nascosti: serve VIEW_SENSITIVE_AUDIT_VALUES, concesso solo dal proprietario.",
  "audit.deniedNote": "Una riga «Negato» mostra che viene registrato anche un tentativo senza permesso.",
  "area.account": "Account",
  "area.access": "Accesso",
  "area.onboarding": "Iscrizione pro",
  "area.discovery": "Ricerca",
  "area.jobs": "Richieste",
  "area.leads": "Opportunità",
  "area.messaging": "Messaggi",
  "area.reviews": "Recensioni",
  "area.payments": "Pagamenti",
  "area.support": "Pratiche",
  "area.safety": "Sicurezza",
  "area.settings": "Impostazioni",
  "area.staff": "Team",
  "area.audit": "Audit",

  // ── Roles & team ──
  "team.members": "Team",
  "team.col.name": "Nome",
  "team.col.roles": "Ruoli",
  "team.col.status": "Stato",
  "team.col.lastSeen": "Ultimo accesso",
  "team.you": "tu",
  "team.noRoles": "Nessun ruolo",
  "team.status.active": "Attivo",
  "team.status.invited": "Invitato",
  "team.status.deactivated": "Disattivato",
  "team.sessions": "{count} sessioni aperte",
  "team.sessionsOne": "1 sessione aperta",
  "team.lastSeen.never": "Mai connesso",
  "team.lastSeen.today": "oggi alle {time}",
  "team.lastSeen.yesterday": "ieri alle {time}",
  "team.lastSeen.date": "il {date}",
  "team.invite": "Invita",
  "team.manageRoles": "Ruoli",
  "team.endSessions": "Chiudi la sessione",
  "team.deactivate": "Disattiva",
  "team.loading": "Caricamento del team…",
  "team.loadFailed": "Non è stato possibile caricare il team.",
  "team.retry": "Riprova",
  "team.emptyStaff": "Nessuno nel team per ora.",
  "team.grid": "Ruoli × funzionalità",
  "team.grid.feature": "Funzionalità",
  "team.grid.editable": "Clicca per concedere o revocare · «critical» richiede il proprietario",
  "team.grid.readOnly": "🔒 Sola lettura · per modificare serve MANAGE_ROLES o ASSIGN_ROLES",
  "team.grid.members": "{count} membri",
  "team.grid.membersOne": "1 membro",
  "team.grid.yourRole": "🔒 il tuo ruolo",
  "team.grid.newRole": "Nuovo ruolo",
  "team.grid.editRole": "Modifica",
  "team.grid.noRoles": "Non esiste ancora alcun ruolo.",
  "team.lock.ownRole": "Hai questo ruolo: nessuno modifica ciò che concede il proprio ruolo.",
  "team.lock.critical": "Critica: solo il proprietario può concederla o revocarla.",
  "team.lock.high": "Sensibilità alta: serve MANAGE_ROLES e avere a propria volta questa funzionalità.",
  "team.lock.low": "Serve MANAGE_ROLES o ASSIGN_ROLES.",
  "team.lock.criticalShort": "🔒 proprietario",
  "team.lock.highShort": "🔒 oltre i tuoi permessi",
  "team.cell.grant": "Concedi {feature} al ruolo {role}",
  "team.cell.revoke": "Revoca {feature} dal ruolo {role}",
  "team.sensitivity.low": "low",
  "team.sensitivity.high": "high",
  "team.sensitivity.critical": "critical",

  "team.reason": "Motivo",
  "team.reasonHint": "Registrato nel registro di audit. Bastano poche parole.",
  "team.reasonTooShort": "Indica un motivo di almeno 3 caratteri.",
  "team.cancel": "Annulla",
  "team.close": "Chiudi",
  "team.sending": "Invio…",
  "team.reload": "Ricarica",
  "team.refused": "Negato: {message}",
  "team.stale":
    "Qualcuno ha modificato questo elemento nel frattempo. Ricarica per vedere la versione attuale, poi riprova.",

  "team.grant.title": "Concedi una funzionalità",
  "team.revoke.title": "Revoca una funzionalità",
  "team.grant.body": "Concedi {feature} al ruolo {role} ({members}).",
  "team.revoke.body": "Revoca {feature} dal ruolo {role} ({members}).",
  "team.grant.submit": "Concedi",
  "team.revoke.submit": "Revoca",
  "team.grant.done": "{feature} concessa al ruolo {role}.",
  "team.revoke.done": "{feature} revocata dal ruolo {role}.",
  "team.critical.note": "Funzionalità critica: i proprietari saranno avvisati.",

  "team.invite.title": "Invita un membro del team",
  "team.invite.name": "Nome completo",
  "team.invite.email": "Email di lavoro",
  "team.invite.phone": "Telefono",
  "team.invite.phoneHint": "Formato internazionale, ad es. +224621234567.",
  "team.invite.roles": "Ruoli",
  "team.invite.noRoles": "Crea prima un ruolo — puoi invitare ora e assegnare i ruoli dopo.",
  "team.invite.rolesHint": "Senza ruolo aprirà una console in cui non è accessibile nulla.",
  "team.invite.sms":
    "Un codice di 6 cifre verrà inviato via SMS a questo numero. Valido {hours} ore, permette di scegliere la password nella pagina «Scegli la mia password».",
  "team.invite.submit": "Invia l'invito",
  "team.invite.done": "{name} è stato invitato. Codice inviato via SMS, valido fino al {until}.",
  "team.invite.missing": "Inserisci nome, email e telefono.",

  "team.deactivate.title": "Disattiva {name}",
  "team.deactivate.body":
    "{name} non potrà mai più accedere. Le sue sessioni aperte e l'eventuale invito terminano immediatamente. Un membro disattivato non viene eliminato.",
  "team.deactivate.submit": "Disattiva",
  "team.deactivate.done": "{name} è disattivato. Sessioni chiuse: {count}.",
  "team.reactivate": "Riattiva",
  "team.reactivate.title": "Riattivare {name}",
  "team.reactivate.body":
    "{name} potrà accedere di nuovo, con i ruoli che aveva già. L'accesso riparte da zero: nessuna sessione né codice viene ripristinato.",
  "team.reactivate.submit": "Riattiva",
  "team.reactivate.done": "{name} è di nuovo attivo.",

  "team.endSessions.title": "Chiudi le sessioni di {name}",
  "team.endSessions.body": "{name} verrà disconnesso ovunque ({sessions}).",
  "team.endSessions.self": "Sono le tue sessioni: verrai disconnesso anche tu.",
  "team.endSessions.submit": "Chiudi",
  "team.endSessions.done": "Sessioni di {name} chiuse: {count}.",

  "team.roles.title": "Ruoli di {name}",
  "team.roles.held": "Ruoli attuali",
  "team.roles.available": "Altri ruoli",
  "team.roles.none": "Nessuno",
  "team.roles.assign": "Assegna {role}",
  "team.roles.remove": "Rimuovi {role}",
  "team.roles.assignDone": "{role} assegnato a {name}.",
  "team.roles.removeDone": "{role} rimosso a {name}.",
  "team.roles.reasonFirst": "Indica prima un motivo, poi scegli il ruolo da assegnare o rimuovere.",

  "team.role.createTitle": "Nuovo ruolo",
  "team.role.editTitle": "Modifica il ruolo {name}",
  "team.role.name": "Nome del ruolo",
  "team.role.description": "Descrizione",
  "team.role.descriptionHint": "Facoltativa. Cosa fa questo ruolo, in una frase.",
  "team.role.department": "Reparto",
  "team.role.noDepartment": "Nessuno",
  "team.role.departmentHint":
    "Lo spazio in cui arrivano i titolari. Ciò che il ruolo consente resta deciso dalle funzionalità.",
  "team.role.create": "Crea il ruolo",
  "team.role.save": "Salva",
  "team.role.created": "Ruolo {name} creato. Concedigli delle funzionalità nella griglia.",
  "team.role.saved": "Ruolo {name} salvato.",
  "team.role.nameTooShort": "Il nome deve avere almeno 2 caratteri.",
  "team.role.unchanged": "Modifica il nome o la descrizione.",
  "team.role.version": "Versione {version}",

  // ── Permissions on a role (ADR-0019) and who can do this ──
  "team.tab.roles": "Ruoli e team",
  "team.tab.who": "Chi può farlo",
  "team.tabs.aria": "Sezioni del team",
  "team.permission.noLimit": "Nessun limite",
  "team.permission.lockFeature":
    "Concedi prima {feature} al ruolo {role}: un permesso conta solo sotto la sua funzionalità.",
  "team.cell.grantPermission": "Concedere {permission} al ruolo {role}",
  "team.cell.editPermission": "Modificare {permission} per il ruolo {role}",
  "team.permission.grantTitle": "Concedi un permesso",
  "team.permission.editTitle": "Modifica un permesso",
  "team.permission.grantBody": "Concedere {permission} al ruolo {role} ({members}).",
  "team.permission.editBody": "Il ruolo {role} ({members}) ha {permission}.",
  "team.permission.under": "Sotto {feature}.",
  "team.permission.approvable": "Senza di esso, il loro tentativo diventa una richiesta di approvazione.",
  "team.permission.refusable": "Senza di esso, l'azione è rifiutata.",
  "team.permission.limits": "Limiti",
  "team.permission.limitsHint":
    "Il massimo che i titolari possono fare da soli in ogni valuta. Oltre, o in una valuta senza limite, diventa una richiesta di approvazione.",
  "team.permission.noLimitHint": "Nessun limite: i titolari agiscono da soli, qualunque sia l'importo.",
  "team.permission.currency": "Valuta",
  "team.permission.amount": "Importo",
  "team.permission.addLimit": "Aggiungere un limite in un'altra valuta",
  "team.permission.removeLimit": "Rimuovere il limite in {currency}",
  "team.permission.limitProblem": "Indica una valuta di tre lettere e un importo superiore a zero per ogni limite.",
  "team.permission.duplicateCurrency": "Un limite per valuta: {currency} è indicata due volte.",
  "team.permission.grantDone": "{permission} concesso al ruolo {role}.",
  "team.permission.revokeDone": "{permission} revocato al ruolo {role}.",
  "team.revoke.permissionsToo": "I permessi sotto di essa vanno con essa: {permissions}.",
  "team.refused.sensitivity":
    "Il tuo accesso non consente di concederlo o revocarlo. Chiedi a un Ops Manager o al proprietario.",
  "team.refused.critical": "Critico: solo un proprietario che lo ha lo concede o lo revoca.",
  "team.refused.limitAboveOwn": "Non puoi concedere un limite più alto del tuo. Chiedi al proprietario.",
  "team.refused.featureFirst":
    "Questo permesso poggia su una funzionalità che il ruolo non concede. Concedi prima la funzionalità.",
  "team.refused.notLimited": "Questo permesso non porta alcun limite.",
  "team.refused.limitWithoutGrant": "Un limite va con un permesso concesso.",
  "team.refused.ownRole": "Hai questo ruolo, quindi non puoi cambiare ciò che concede. Chiedi a un altro proprietario.",
  "team.who.action": "Azione",
  "team.who.feature": "Funzionalità",
  "team.who.permission": "Permesso",
  "team.who.noPermission": "Nessun permesso copre questa azione: chi ha la funzionalità può eseguirla.",
  "team.who.approvable": "può essere richiesto",
  "team.who.col.through": "Tramite",
  "team.who.col.limit": "Limite",
  "team.who.personal": "Impostato per questa persona",
  "team.who.mayRequest": "Può solo chiedere: diventa una richiesta di approvazione",
  "team.who.loading": "Caricamento di chi può farlo…",
  "team.who.loadFailed": "Impossibile caricare chi può farlo.",
  "team.who.empty": "Nessuno può farlo.",

  // ── Customers & pros ──
  // Trades, by WorkerCategory.
  "trade.electrician": "Elettricista",
  "trade.plumber": "Idraulico",
  "trade.mason": "Muratore",
  "trade.carpenter": "Falegname",
  "trade.ac_technician": "Tecnico climatizzatori",
  "trade.cleaner": "Addetta alle pulizie",
  "trade.painter": "Imbianchino",
  "trade.handyman": "Tuttofare",
  "trade.laundry": "Lavanderia",
  "trade.babysitter": "Baby-sitter",
  "trade.fridge_repair": "Riparatore di frigoriferi",
  "trade.moto_driver": "Mototaxi",
  "trade.tailor": "Sarto",
  "trade.car_mechanic": "Meccanico auto",
  "trade.welder": "Saldatore",
  "trade.gardener": "Giardiniere",
  "trade.phone_repair": "Riparatore di telefoni",
  "trade.tutor": "Insegnante di ripetizioni",
  "trade.hairdresser": "Parrucchiere",
  "trade.security_guard": "Guardiano",
  "trade.other": "Altro",
  // A number with its unit (the settings' Unit).
  "unit.km": "{value} km",
  "unit.minutes": "{value} min",
  "unit.hours": "{value} h",
  "unit.days": "{value} g",
  "unit.seconds": "{value} s",

  "customers.search.label": "Cerca un cliente o un pro",
  "customers.search.placeholder": "Nome, telefono, email o ID dell'account",
  "customers.search.hint": "Ad es. «621 23 45 67», «Sékou Touré», «mariama.bah@» o l'ID dell'account.",
  "customers.search.submit": "Cerca",
  "customers.search.tooShort": "Inserisci almeno 2 caratteri.",
  "customers.search.locked": "La ricerca richiede",
  "customers.search.idle": "Inserisci un nome, un numero, un'email o un ID per trovare un account.",
  "customers.search.loading": "Ricerca…",
  "customers.search.loadFailed": "Non è stato possibile completare la ricerca.",
  "customers.search.empty": "Nessun account corrisponde a «{query}».",
  "customers.search.matchedBy.userId": "Ricerca per ID dell'account",
  "customers.search.matchedBy.email": "Ricerca per email",
  "customers.search.matchedBy.phone": "Ricerca per telefono",
  "customers.search.matchedByPhone": "Ricerca per telefono: {phone}",
  "customers.search.matchedBy.name": "Ricerca per nome",
  "customers.search.count": "{count} account mostrati",
  "customers.search.countOne": "1 account mostrato",
  "customers.search.end": "Fine dei risultati.",
  "customers.search.loadMore": "Carica altro",
  "customers.search.loadingMore": "Caricamento…",
  "customers.search.moreFailed":
    "Non è stato possibile caricare la pagina successiva. Gli account già mostrati restano validi.",
  "customers.search.retry": "Riprova",
  "customers.search.masked":
    "Numeri ed email nascosti. «Mostra», nella pagina dell'account e con un motivo, viene registrato.",
  "customers.col.name": "Nome",
  "customers.col.contact": "Contatto",
  "customers.col.kind": "Cliente o pro",
  "customers.col.region": "Regione",
  "customers.col.since": "Membro dal",
  "customers.deleted": "Account eliminato",
  "customers.deletedName": "Nome cancellato",
  "customers.kind.client": "Cliente",
  "customers.kind.pro": "Pro",
  "customers.kind.proAndClient": "Pro e cliente",
  "customers.kind.admin": "Amministratore",
  "customers.region.gn": "Guinea",
  "customers.region.sn": "Senegal",
  "customers.region.us": "Stati Uniti",
  "customers.region.eu": "Europa",
  "customers.verification.unverified": "Non verificata",
  "customers.verification.pending": "In attesa",
  "customers.verification.verified": "Verificata",
  "customers.verification.rejected": "Rifiutata",

  "customers.back": "← Ricerca",
  "customers.page.loading": "Caricamento dell'account…",
  "customers.page.loadFailed": "Non è stato possibile caricare l'account.",
  "customers.page.notFound": "Nessun account ha questo ID. Cerca di nuovo la persona.",
  "customers.page.locked": "La pagina di un account richiede",
  "customers.page.sub": "{kind} · membro dal {since} · {region}",
  "customers.page.deletedTitle": "Account eliminato",
  "customers.page.deletedSub": "Eliminato il {date} · nome e contatti cancellati",

  "customers.reveal.button": "Mostra",
  "customers.reveal.locked": "🔒 nascosto",
  "customers.reveal.lockedTitle": "Mostrare i contatti richiede REVEAL_CONTACT_DETAILS_STAFF_FEATURE_ENABLEMENT",
  "customers.reveal.title": "Mostra i contatti di {name}",
  "customers.reveal.body":
    "Il numero e l'email completi vengono mostrati solo in questa pagina, per la durata della tua consultazione. La visualizzazione viene registrata nel registro dell'account, con il tuo motivo.",
  "customers.reveal.reason": "Motivo",
  "customers.reveal.placeholder": "Perché? es. richiamare il cliente, pratica D-0142",
  "customers.reveal.tooShort": "Indica un motivo di almeno 3 caratteri.",
  "customers.reveal.submit": "Mostra",
  "customers.reveal.sending": "Invio…",
  "customers.reveal.cancel": "Annulla",
  "customers.reveal.noAnswer":
    "Nessuna risposta dal server: la visualizzazione potrebbe essere stata registrata senza che i contatti ti siano arrivati. Riprova; anche la nuova visualizzazione verrà registrata.",
  "customers.reveal.recorded": "Mostrato alle {time} · consultazione registrata nel registro dell'account.",
  "customers.reveal.hide": "Nascondi",
  "customers.reveal.phone": "Telefono:",
  "customers.reveal.email": "Email:",
  "customers.reveal.none": "nessuno",

  "customers.obo.title": "Agisci per conto di {name}",
  "customers.obo.body":
    "Un codice viene inviato via SMS al numero dell'account. Il cliente lo legge ad alta voce; la sessione dura 30 minuti e ogni azione viene registrata con il suo nome e il tuo.",
  "customers.obo.send": "Invia il codice",
  "customers.obo.soon": "Presto disponibile",

  "customers.tabs.aria": "Sezioni dell'account",
  "customers.tab.overview": "Panoramica",
  "customers.tab.subscription": "Abbonamento",
  "customers.tab.settings": "Funzionalità e impostazioni",
  "customers.tab.jobs": "Richieste",
  "customers.tab.audit": "Registro",

  "customers.pro.title": "Profilo pro",
  "customers.pro.none": "Nessun profilo pro.",
  "customers.pro.identity": "Identità",
  "customers.pro.approval": "Approvazione",
  "customers.pro.rating": "Valutazione",
  "customers.pro.ratingValue": "{rating} ★ · {count} recensioni",
  "customers.pro.noReviews": "Nessuna recensione",
  "customers.pro.rate": "Tariffa",
  "customers.pro.subscription": "Piano",
  "customers.pro.noSubscription": "Nessuno",
  "customers.pro.subscriptionLine": "{plan} · {status}",
  "customers.pro.paidUntil": "{plan} · pagato fino al {date}",
  "customers.pro.endingUntil": "{plan} · attiva fino al {date}, senza rinnovo",
  "customers.pro.approval.pending": "In attesa",
  "customers.pro.approval.approved": "Approvato",
  "customers.pro.approval.rejected": "Rifiutato",
  "customers.subscription.pending": "in attesa",
  "customers.subscription.active": "attivo",
  "customers.subscription.ending": "senza rinnovo",
  "customers.subscription.suspended": "sospesa",
  "customers.subscription.ended": "terminata",
  "customers.rate.hourly": "{amount} / ora",
  "customers.rate.daily": "{amount} / giorno",
  "customers.rate.fixed": "{amount} forfettario",
  "customers.client.title": "Profilo cliente",
  "customers.client.jobsPosted": "Richieste pubblicate",
  "customers.client.lastActivity": "Ultima attività",
  "customers.client.never": "Nessuna",
  "customers.restrictions.title": "Restrizioni attive",
  "customers.restrictions.none": "Nessuna restrizione.",
  "customers.restrictions.suspension": "Sospensione provvisoria",
  "customers.restrictions.line": "{feature} disabilitata per {scope} · motivo: {reason}",
  "customers.restrictions.until": "fino al {date}",

  "customers.settings.col.setting": "Impostazione",
  "customers.settings.col.value": "Valore",
  "customers.settings.col.source": "Livello",
  "customers.settings.col.reason": "Motivo",
  "customers.settings.col.expires": "Scade",
  "customers.settings.on": "Abilitata",
  "customers.settings.off": "Disabilitata",
  "customers.settings.restricted": "Limitata",
  "customers.settings.none": "Nessuna impostazione si applica a questo account.",
  "customers.settings.edit": "Modifica un'impostazione",
  "customers.settings.editSoon":
    "Presto disponibile: la modifica delle impostazioni di un cliente arriverà in una prossima versione.",
  "customers.settings.foot":
    "Prevale il livello più specifico: persona, profilo pro, tutti i pro o tutti i clienti, regione, sistema, poi il valore predefinito.",
  "customers.source.user": "Persona",
  "customers.source.proProfile": "Profilo pro",
  "customers.source.allPros": "Tutti i pro",
  "customers.source.allClients": "Tutti i clienti",
  "customers.source.region": "Regione",
  "customers.source.regionOf": "Regione {region}",
  "customers.source.appVersion": "Versione dell'app",
  "customers.source.system": "Sistema",
  "customers.source.default": "Predefinito",
  "customers.scope.user": "la persona",
  "customers.scope.proProfile": "il profilo pro",

  "customers.jobs.col.trade": "Mestiere",
  "customers.jobs.col.type": "Tipo",
  "customers.jobs.col.side": "Ruolo",
  "customers.jobs.col.other": "Con",
  "customers.jobs.col.status": "Stato",
  "customers.jobs.col.date": "Data",
  "customers.jobs.type.direct": "Diretta",
  "customers.jobs.type.open": "Aperta",
  "customers.jobs.side.client": "Cliente",
  "customers.jobs.side.pro": "Pro",
  "customers.jobs.status.requested": "Richiesta",
  "customers.jobs.status.quoted": "Preventivo inviato",
  "customers.jobs.status.accepted": "Presentazione fatta",
  "customers.jobs.status.cancelled": "Annullata",
  "customers.jobs.noPro": "Nessun pro scelto",
  "customers.jobs.deletedParty": "Account eliminato",
  "customers.jobs.none": "Nessuna richiesta per questo account.",
  "customers.jobs.foot": "Al massimo le ultime {count} richieste, come cliente o come pro.",

  "customers.journal.recorded": "Anche la tua consultazione di questo registro viene registrata.",
  "customers.journal.locked": "Il registro di audit richiede",
  "customers.lockedRoles": "I tuoi ruoli ({roles}) non lo includono.",
  "customers.journal.onBehalf": "per conto di {id}",
  "customers.journal.actorWithRoles": "{name} ({roles})",
  "customers.journal.reason": "motivo: {reason}",
  "customers.journal.empty": "Non è ancora stato registrato nulla per questo account.",
  "customers.journal.all": "Apri nel registro di audit →",
  "customers.journal.denied": "negato",
  "customers.journal.succeeded": "riuscito",

  // ── Choose my password (public) ──
  "setPassword.title": "Scegli la mia password",
  "setPassword.subtitle": "Usa il codice di 6 cifre ricevuto via SMS con il tuo invito.",
  "setPassword.email": "Email di lavoro",
  "setPassword.code": "Codice ricevuto via SMS",
  "setPassword.password": "Nuova password",
  "setPassword.confirm": "Conferma la password",
  "setPassword.rules": "La password deve:",
  "setPassword.rule.length": "avere almeno {min} caratteri",
  "setPassword.rule.tooLong": "avere al massimo {max} caratteri",
  "setPassword.rule.mix": "contenere una lettera e un carattere che non sia una lettera",
  "setPassword.rule.email": "non contenere la tua email ({name})",
  "setPassword.rule.emailGeneric": "non contenere la tua email",
  "setPassword.mismatch": "Le due password non coincidono.",
  "setPassword.codeFormat": "Il codice è composto da 6 cifre.",
  "setPassword.emailFormat": "Inserisci un'email valida.",
  "setPassword.submit": "Salva la mia password",
  "setPassword.submitting": "Salvataggio…",
  "setPassword.back": "Torna all'accesso",
  "setPassword.done": "Password salvata. Accedi con la tua email e questa password.",
  "signIn.setPassword": "Invitato? Scegli la mia password",
  "signIn.or": "oppure",
  "signIn.heading": "Console Walliyo",
  "signIn.forgot": "Password dimenticata?",
  "signIn.environment": "Ambiente",
  "signIn.build": "Build",
  "signIn.googleUnavailable":
    "L'accesso con Google non è disponibile. Usa e-mail e password, oppure avvisa il proprietario.",
  "error.setPassword.invalid_code":
    "Questa email e questo codice non corrispondono a nessun invito aperto. Controlla entrambi; se il codice è perso o scaduto, chiedi di essere invitato di nuovo.",
  "error.setPassword.too_many_attempts":
    "Troppi codici errati: questo codice non è più valido. Chiedi di essere invitato di nuovo.",
  "error.setPassword.validation_error":
    "La password non rispetta le regole, o il codice non ha il formato corretto. Correggi e riprova.",

  // ── Dossiers (the support case queue) ──
  "cases.newCall": "+ Registra una chiamata",
  "cases.queue.aria": "Coda delle pratiche",
  "cases.queue.views": "Viste della coda",
  "cases.view.all": "Tutte",
  "cases.view.unassigned": "Non assegnate",
  "cases.view.mine": "Le mie",
  "cases.view.late": "In ritardo",
  "cases.filter.status": "Stato",
  "cases.filter.notClosed": "Tutte tranne le chiuse",
  "cases.filter.channel": "Canale",
  "cases.filter.anyChannel": "Tutti i canali",
  "cases.filter.customer": "Cliente {id}",
  "cases.filter.clear": "Rimuovi il filtro cliente",
  "cases.col.case": "Pratica",
  "cases.col.deadline": "Scadenza",
  "cases.queue.loading": "Caricamento della coda…",
  "cases.queue.loadFailed": "Non è stato possibile caricare la coda.",
  "cases.queue.empty": "Nessuna pratica corrisponde a questi filtri.",
  "cases.loadMore": "Carica altro",
  "cases.loadingMore": "Caricamento…",
  "cases.retry": "Riprova",
  "cases.pick": "Scegli una pratica nella coda per vederne la cronologia.",
  "cases.loading": "Caricamento della pratica…",
  "cases.loadFailed": "Non è stato possibile caricare questa pratica.",
  "cases.notFound": "Nessuna pratica ha questo ID. Forse è stato copiato male.",
  "cases.refreshFailed": "Non è stato possibile aggiornare la pratica: ciò che vedi potrebbe non essere aggiornato.",
  "cases.deadline.late": "In ritardo · {time}",
  "cases.deadline.left": "mancano {time}",
  "cases.deadline.replied": "Risposto",
  "cases.deadline.closed": "Chiusa",
  "cases.channel.phone": "Chiamata",
  "cases.channel.email": "Email",
  "cases.channel.chat": "Chat in app",
  "cases.status.open": "Aperta",
  "cases.status.waiting_on_customer": "In attesa del cliente",
  "cases.status.closed": "Chiusa",
  "access.mine.title": "Che cosa hai chiesto",
  "access.mine.none": "Non hai chiesto nulla.",
  "access.mine.what": "Che cosa",
  "access.mine.state": "A che punto è",
  "access.mine.asked": "Chiesto",
  "access.mine.withWhom": "Presso",
  "access.mine.waiting": "In attesa",
  "access.mine.granted": "Concesso",
  "access.mine.refused": "Rifiutato",
  "access.mine.overdue": "In ritardo",
  "access.mine.nobody": "Ancora nessuno",
  "access.mine.answer": "Risposta",
  "access.mine.loading": "Caricamento delle tue richieste…",
  "access.mine.loadFailed": "Non è stato possibile leggere le tue richieste.",
  "access.ask.title": "Chiedere di più",
  "access.ask.explain":
    "Costruire la cosa non è una ragione per detenerne i dati. Chiedi il minimo che ti permette di finire, per il tempo che ti serve. Va a chi può concederlo, è concesso a te soltanto, e termina da sé.",
  "access.ask.what": "Di cosa hai bisogno",
  "access.ask.until": "Fino al",
  "access.ask.why": "Perché ti serve",
  "access.ask.whyHint": "Che cosa stai facendo, e perché questo è il minimo che te lo permette",
  "access.ask.send": "Invia la richiesta",
  "access.ask.pickOne": "Scegli ciò che ti serve",
  "access.ask.pastDate": "Indica una data futura, o lascia aperto.",
  "access.ask.sent": "Inviato. È il caso {reference}.",
  "cases.kind.access": "Richiesta di accesso",
  "cases.kind.customer": "Cliente",
  "cases.kind": "Tipo",
  "cases.access.wants": "Chiede",
  "cases.access.until": "Fino al",
  "cases.access.grant": "Concedere",
  "cases.access.refuse": "Rifiutare",
  "cases.access.own": "Non puoi rispondere alla tua stessa richiesta.",
  "cases.access.explain":
    "Concesso a questa persona soltanto, mai al suo team. Termina alla data richiesta, e chiunque ne abbia l'autorità può interromperlo prima.",
  "cases.priority": "Priorità: {priority}",
  "cases.priority.low": "Bassa",
  "cases.priority.normal": "Normale",
  "cases.priority.high": "Alta",
  "cases.priority.urgent": "Urgente",
  "cases.unknownCaller": "Chiamante sconosciuto",
  "cases.unknownCallerPhone": "Chiamante sconosciuto · {phone}",
  "cases.customerWithPhone": "{name} · {phone}",
  "cases.ownedBy": "assegnata a {name}",
  "cases.unassigned": "non assegnata",
  "cases.closedBecause": "Chiusa · motivo: {reason}",
  "cases.timeline.aria": "Cronologia della pratica",
  "cases.timeline.empty": "Non è ancora stato registrato nulla su questa pratica.",
  "cases.internal": "Interno",
  "cases.entry.call": "Chiamata",
  "cases.entry.callWithDuration": "Chiamata ({duration})",
  "cases.entry.note": "Nota interna",
  "cases.entry.chatIn": "Messaggio del cliente nell'app",
  "cases.entry.chatOut": "Risposta nell'app",
  "cases.entry.smsIn": "SMS del cliente",
  "cases.entry.smsOut": "Risposta via SMS",
  "cases.entry.smsOutTo": "SMS al {phone}",
  "cases.entry.emailIn": "Email del cliente",
  "cases.entry.emailOut": "Risposta via email",
  "cases.sms.pending": "Invio in corso",
  "cases.sms.sent": "Inviato",
  "cases.sms.failed": "Non inviato",
  "cases.action.claim": "Prendi in carico",
  "cases.action.reassign": "Riassegna",
  "cases.action.link": "Collega a un cliente",
  "cases.action.relink": "Cambia cliente",
  "cases.action.close": "Chiudi",
  "cases.needs": "Richiede {feature}",
  "cases.sending": "Invio…",
  "cases.cancel": "Annulla",
  "cases.reload": "Ricarica la pratica",
  "cases.reason": "Motivo",
  "cases.reasonHint": "Registrato nel registro di audit con il tuo nome.",
  "cases.stale":
    "Questa pratica è cambiata mentre la guardavi. Ricaricala, controlla cosa è cambiato e riprova: il tuo testo viene conservato.",
  "cases.claim.done": "{reference} è tua.",
  "cases.claim.taken": "Troppo tardi: {name} ha appena preso in carico questa pratica. Scegline un'altra.",
  "cases.composer.aria": "Scrivi sulla pratica",
  "cases.composer.reply": "Rispondi",
  "cases.composer.note": "Nota interna",
  "cases.composer.call": "Registra una chiamata",
  "cases.reply.noChannel":
    "Nessun account cliente collegato: collega il cliente per rispondere nell'app, oppure richiamalo.",
  "cases.reply.notified": "Il cliente riceve una notifica nell'app. Mai un SMS.",
  "cases.reply.label": "Risposta a {name}",
  "cases.reply.sendChat": "Invia nell'app",
  "cases.reply.doneChat": "Risposta inviata nell'app.",
  "cases.reply.closed": "Questa pratica è chiusa: non accetta più risposte.",
  "cases.reply.unassigned": "Prendi in carico questa pratica per rispondere al cliente.",
  "cases.reply.notOwner": "Solo il responsabile della pratica risponde al cliente. Chiedi una riassegnazione se serve.",
  "cases.refused.claimed": "Troppo tardi: qualcun altro ha appena preso questa pratica. Scegline un'altra.",
  "cases.refused.closed": "Questa pratica è stata chiusa nel frattempo. Ricaricala.",
  "cases.refused.notOwner":
    "Questa pratica ora appartiene a qualcun altro. Ricaricala, o chiedi che ti venga riassegnata.",
  "cases.refused.noCustomer":
    "Nessun account cliente collegato: collega il cliente per rispondere nell'app, oppure richiamalo.",
  "cases.note.hint": "Visibile solo al team, mai al cliente.",
  "cases.note.label": "Nota interna",
  "cases.note.submit": "Aggiungi la nota",
  "cases.note.done": "Nota interna aggiunta.",
  "cases.call.label": "Cosa è stato detto (riepilogo interno)",
  "cases.call.minutes": "Durata (minuti)",
  "cases.call.submit": "Registra la chiamata",
  "cases.call.done": "Chiamata registrata.",
  "cases.reassign.title": "Riassegna {reference}",
  "cases.reassign.from": "Attualmente assegnata a {name}.",
  "cases.reassign.unassigned": "Questa pratica non è ancora assegnata a nessuno.",
  "cases.reassign.to": "Nuovo responsabile",
  "cases.reassign.choose": "Scegli un membro del team",
  "cases.reassign.loading": "Caricamento del team…",
  "cases.reassign.toId": "ID del membro del team",
  "cases.reassign.idHint": "Senza accesso all'elenco del team, incolla l'ID del membro.",
  "cases.reassign.submit": "Riassegna",
  "cases.reassign.done": "Pratica riassegnata a {name}.",
  "cases.close.title": "Chiudi {reference}",
  "cases.close.body": "Il cliente non potrà più rispondere; se torna, verrà aperta una nuova pratica.",
  "cases.close.submit": "Chiudi la pratica",
  "cases.close.done": "{reference} è chiusa.",
  "cases.link.title": "Collega {reference} a un cliente",
  "cases.link.body": "Trova l'account del cliente che ha contattato l'assistenza.",
  "cases.link.caller": "Il chiamante ha dato il {phone}. Trova il suo account.",
  "cases.link.current": "Attualmente collegata a {name}.",
  "cases.link.submit": "Collega",
  "cases.link.done": "Pratica collegata a {name}.",
  "cases.customer.search": "Cerca il cliente",
  "cases.customer.placeholder": "Nome, telefono, email o ID",
  "cases.customer.searchButton": "Cerca",
  "cases.customer.searching": "Ricerca…",
  "cases.customer.none": "Nessun account trovato.",
  "cases.customer.results": "Account trovati",
  "cases.customer.id": "ID dell'account cliente",
  "cases.customer.idHint": "La ricerca richiede {feature}: incolla l'ID dell'account.",
  "cases.newCall.title": "Registra una chiamata",
  "cases.newCall.who": "Chi ha chiamato?",
  "cases.newCall.known": "Un cliente",
  "cases.newCall.unknown": "Un chiamante sconosciuto",
  "cases.newCall.phone": "Numero del chiamante",
  "cases.newCall.phoneHint": "In formato internazionale, per esempio +224 621 23 45 67.",
  "cases.newCall.subject": "Oggetto",
  "cases.newCall.internal": "Interno: il cliente non vede mai questo riepilogo.",
  "cases.newCall.priority": "Priorità",
  "cases.newCall.submit": "Apri la pratica",
  "cases.problem.reason": "Di' perché, in poche parole.",
  "cases.problem.body": "Scrivi qualcosa.",
  "cases.problem.tooLong": "Troppo lungo: al massimo {max} caratteri.",
  "cases.problem.minutes": "La durata è un numero intero di minuti, da 0 a {max}.",
  "cases.problem.phone": "Il numero deve essere in formato internazionale, per esempio +224621234567.",
  "cases.problem.pickCustomer": "Scegli il cliente.",
  "cases.problem.customerId": "Questo ID account non ha il formato corretto.",
  "cases.problem.pickStaff": "Scegli a chi affidare la pratica.",
  "cases.problem.staffId": "Questo ID membro non ha il formato corretto.",
  "cases.problem.subject": "Dai alla pratica un oggetto breve.",
  // ── Verifiche ──
  "verifications.summary.open": "{count} in attesa · la più vecchia da {age}",
  "verifications.summary.none": "Nessuna verifica in attesa",
  "verifications.summary.shown": "{count} verifiche mostrate",
  "verifications.filter.status": "Stato",
  "verifications.filter.status.open": "Tutte in attesa",
  "verifications.filter.status.submitted": "Da esaminare",
  "verifications.filter.status.flagged": "Documento vietato",
  "verifications.filter.status.approved": "Approvate",
  "verifications.filter.status.rejected": "Respinte",
  "verifications.filter.document": "Tipo di documento",
  "verifications.filter.document.all": "Tutti",
  "verifications.filter.document.national_id": "Carta d'identità",
  "verifications.filter.document.passport": "Passaporto",
  "verifications.queue.aria": "Coda delle verifiche, la più vecchia per prima",
  "verifications.queue.loading": "Caricamento della coda…",
  "verifications.queue.loadFailed": "Impossibile caricare la coda.",
  "verifications.queue.emptyOpen": "Nessuna verifica in attesa: la coda è vuota.",
  "verifications.queue.empty": "Nessuna verifica corrisponde a questi filtri.",
  "verifications.queue.waited": "Tempo di attesa dall'invio",
  "verifications.queue.end": "Fine della coda.",
  "verifications.flag.banned": "Documento vietato",
  "verifications.status.submitted": "Da esaminare",
  "verifications.status.flagged": "Documento vietato",
  "verifications.status.approved": "Approvata",
  "verifications.status.rejected": "Respinta",
  "verifications.document.national_id": "Carta d'identità",
  "verifications.document.passport": "Passaporto",
  "verifications.side.front": "Fronte",
  "verifications.side.back": "Retro",
  "verifications.side.selfie": "Foto selfie",
  "verifications.detail.pick": "Scegli una verifica nella coda per esaminarla.",
  "verifications.detail.loading": "Caricamento della verifica…",
  "verifications.detail.loadFailed": "Impossibile caricare questa verifica.",
  "verifications.detail.notFound": "Nessuna verifica ha questo identificativo. Ricarica la coda.",
  "verifications.detail.noPhone": "senza telefono",
  "verifications.detail.submitted": "inviata il {date}",
  "verifications.detail.versionTitle": "Versione esaminata: una decisione vale solo per questa versione",
  "verifications.banned.title": "Documento vietato",
  "verifications.banned.body":
    "Questo numero corrisponde a un documento vietato il {date} · motivo: {reason}. Non può mai essere approvato: respingi la verifica.",
  "verifications.banned.bodyNoReason":
    "Questo numero corrisponde a un documento vietato. Non può mai essere approvato: respingi la verifica.",
  "verifications.banned.notTold": "Il pro non viene informato che il suo documento è vietato.",
  "verifications.images.aria": "Documenti d'identità",
  "verifications.images.show": "Mostra i documenti",
  "verifications.images.showAgain": "Mostra di nuovo",
  "verifications.images.loading": "Caricamento…",
  "verifications.images.notice":
    "Ogni visualizzazione è registrata nel registro di audit, a tuo nome, e compare nella cronologia del pro. I link scadono dopo 2 minuti.",
  "verifications.images.recorded": "Visualizzazione registrata nel registro di audit · link validi fino alle {time}",
  "verifications.images.hide": "Nascondi",
  "verifications.images.expired":
    "I link sono scaduti e le immagini sono state tolte dallo schermo. Anche una nuova visualizzazione viene registrata.",
  "verifications.images.locked": "Le immagini d'identità richiedono",
  "verifications.images.deleted":
    "Le immagini sono state eliminate il {date}, come richiede la regola di conservazione.",
  "verifications.col.field": "Campo",
  "verifications.col.read": "Letto sul documento",
  "verifications.col.typed": "Inserito dal pro",
  "verifications.col.match": "Corrispondenza",
  "verifications.field.name": "Nome",
  "verifications.field.dateOfBirth": "Nato il",
  "verifications.field.expiresOn": "Scade il",
  "verifications.field.documentNumber": "N. documento",
  "verifications.notAsked": "non richiesto",
  "verifications.match.check": "Da verificare sull'immagine",
  "verifications.match.same": "Corrisponde",
  "verifications.match.different": "Non corrisponde",
  "verifications.match.readOnly": "Solo letto",
  "verifications.match.expired": "Scaduto",
  "verifications.match.valid": "Valido",
  "verifications.match.banned": "Vietato",
  "verifications.match.notBanned": "Non vietato",
  "verifications.last4Hint":
    "Si conservano solo gli ultimi 4 caratteri del numero ({last4}): confrontali con l'immagine.",
  "verifications.standing.title": "Account del pro oggi",
  "verifications.standing.verificationStatus": "Stato della verifica",
  "verifications.standing.approvalStatus": "Approvazione del profilo",
  "verifications.standing.isVerified": "Badge «verificato»",
  "verifications.standing.status.unverified": "Non verificato",
  "verifications.standing.status.pending": "In esame",
  "verifications.standing.status.verified": "Verificato",
  "verifications.standing.status.rejected": "Respinto",
  "verifications.standing.approval.pending": "Da approvare",
  "verifications.standing.approval.approved": "Approvato",
  "verifications.standing.approval.rejected": "Non approvato",
  "verifications.yes": "Sì",
  "verifications.no": "No",
  "verifications.previous.title": "Invii precedenti",
  "verifications.previous.none": "Primo invio di questo pro.",
  "verifications.approve.button": "Approva il pro",
  "verifications.reject.button": "Respingi",
  "verifications.decided": "Questa verifica è già stata decisa.",
  "verifications.approve.banned":
    "Impossibile approvare: il numero corrisponde a un documento vietato. Respingi la verifica.",
  "verifications.approve.locked":
    "Approvare richiede anche APPROVE_PROS_STAFF_FEATURE_ENABLEMENT, che i tuoi ruoli non includono.",
  "verifications.decided.approved": "Approvata da {name} il {date}.",
  "verifications.decided.rejected": "Respinta da {name} il {date}.",
  "verifications.decided.reasonCode": "Motivo: {reason}",
  "verifications.decided.reason": "Nota del team: «{reason}»",
  "verifications.outcome.approved": "{name} è approvato: il profilo è verificato e può essere trovato e ingaggiato.",
  "verifications.outcome.rejected": "Verifica rifiutata. Il professionista viene avvisato nell'app, nella sua lingua.",
  "verifications.approve.title": "Approva {name}",
  "verifications.approve.body":
    "Il documento è accettato e il pro diventa verificato: può essere trovato e ingaggiato. La decisione è registrata nel registro di audit con il tuo motivo.",
  "verifications.approve.reason": "Motivo (registrato nel registro di audit)",
  "verifications.approve.hint": "Ad es. «Carta leggibile, selfie conforme».",
  "verifications.approve.submit": "Approva il pro",
  "verifications.approve.tooShort": "Indica un motivo di almeno {min} caratteri.",
  "verifications.reject.title": "Respingi la verifica di {name}",
  "verifications.reject.body": "Il pro potrà inviare un nuovo documento dall'app.",
  "verifications.reject.preset": "Motivo del rifiuto",
  "verifications.reject.presetNone": "Scegli un motivo…",
  "verifications.reject.code.photo_unreadable": "Foto illeggibile",
  "verifications.reject.code.selfie_mismatch": "Il selfie non corrisponde",
  "verifications.reject.code.document_expired": "Documento scaduto",
  "verifications.reject.code.document_not_accepted": "Documento non accettato",
  "verifications.reject.code.other": "Altro",
  "verifications.reject.reason": "Nota per il team (facoltativa)",
  "verifications.reject.noteHint":
    "Mai mostrata al professionista: riceve nell'app il messaggio del motivo scelto, nella sua lingua.",
  "verifications.reject.submit": "Rifiuta la verifica",
  "verifications.reject.pickCode": "Scegli il motivo del rifiuto.",
  "verifications.reason.tooLong": "Il motivo può avere al massimo {max} caratteri.",
  "verifications.reason.count": "{count} di {max} caratteri",
  "verifications.dialog.version": "Decisione sulla versione {version}",
  "verifications.dialog.cancel": "Annulla",
  "verifications.dialog.sending": "Invio…",
  "verifications.error.stale":
    "Questa verifica è cambiata mentre la guardavi (forse qualcun altro l'ha già decisa). Ricarica per vedere la versione attuale e decidi di nuovo.",
  "verifications.error.approveRefused":
    "Approvazione rifiutata: i tuoi ruoli non includono REVIEW_VERIFICATIONS e APPROVE_PROS, oppure il documento è appena stato vietato. Ricarica.",
  "verifications.error.rejectRefused":
    "Impossibile respingere: i tuoi ruoli non includono più REVIEW_VERIFICATIONS. Chiedi l'accesso a un responsabile.",
  "verifications.error.imagesRefused":
    "Immagini negate: i tuoi ruoli non includono più VIEW_ID_IMAGES. Questo tentativo è registrato nel registro di audit.",
  "verifications.error.approveInvalid":
    "Approvazione rifiutata: la verifica è già decisa, il documento è vietato o il motivo non è valido. Ricarica e controlla.",
  "verifications.error.rejectInvalid":
    "Rifiuto respinto: la verifica è già decisa, oppure la nota supera {max} caratteri.",
  "verifications.error.imagesDeleted":
    "Le immagini non sono più disponibili: sono state eliminate secondo la regola di conservazione, oppure la verifica non si trova.",
  "verifications.error.outcomeUnknown":
    "Nessuna risposta dal server: la decisione potrebbe essere stata salvata. Riprova: lo stesso clic non può essere applicato due volte.",
};
